import React, { useMemo, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  Grid,
  Typography,
  useTheme,
  Divider,
  DialogContent,
  DialogTitle,
  Chip,
  Stack,
  DialogActions,
  alpha,
  IconButton,
  LinearProgress,
  AvatarGroup,
  Tooltip,
  Collapse,
} from "@mui/material";
import { Link as RouterLink, useNavigate, useParams, useSearchParams } from "react-router-dom";
import ProfileTimelineSection from "../../../Components/CommunicationTimeline/ProfileTimelineSection";
import { buildCreateReturnSearch } from "../../Classes/Create/assignmentContext";
import { useCreateClassPath } from "../../StaffPortal/shared/routes";
import {
  parseView,
  viewTargetId,
  isWeeklyView,
  isCalendarView,
  isAssignmentsView,
  SECTION_IDS,
  StaffView,
  parseScheduleView,
  SCHEDULE_VIEW_PARAM,
  ScheduleView,
  CLASS_SCHEDULES_VIEW,
  CLASS_SCHEDULES_TAB_PARAM,
  isClassSchedulesTab,
} from "./staffProfileView";
import WeeklySchedulePlanner from "./Component/WeeklySchedulePlanner";
import ClassSchedulesTab from "./Component/ClassSchedulesTab";
import useUser from "../../../Core/hook/useUser";
import { Privileges } from "../../../Core/Enum/enum";
import {
  useCreateTeamImageMutation,
  useDeleteTeamMutation,
  useGetTeamQuery,
  useGetPositionQuery,
  useGetGradesAssignStaffQuery,
  useGetallSubjectQuery,
  useGetUserAdminOnyQuery,
  useGetUserRoleQuery,
  useToggleStaffPortalAccessMutation,
  useGetStaffPortalAccessQuery,
  useCreateStaffPortalAccountMutation,
  useSendStaffPortalInvitationMutation,
  useSendStaffPasswordResetMutation,
  useSuspendStaffPortalAccessMutation,
  useEnableStaffPortalAccessMutation,
  useGetallGradeQuery,
  useCreateSubjectGradeAssignStaddMutation,
  useGetStaffSubjectAssignmentsQuery,
  useSaveStaffSubjectAssignmentsMutation,
  useGetDepartmentQuery,
  useGetallLocationQuery,
  useGetallEnumSearchQuery,
  useGetStaffDashboardStatsQuery,
  useGetStaffTeachingProfileQuery,
  useGetAssignClassEmpGetAllCalederQuery,
  useGetallAssignClassesQuery,
  useGetallStudentQuery,
  useGetStaffTodaySessionMutation,
} from "../../../Api/attoDeskApi";
import {
  TextField,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  Switch,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import { ITeam, IPosition, ISubject, IGrade, IUserAdmin, IUserRole, IDepartment, IStudentLocation, IEnumType, ISubjectGradeAssign, IStudent } from "../../../Api/Interface/api.interface";
import { skipToken } from "@reduxjs/toolkit/query";
import ChangePassword from "../../User/ChangePassword/index";
import { formatPhoneNumberForDisplay } from "../../../Components/Validation/validationUtils";
import { useNotifier } from "../../../Core/Notifier";
import { uploadImage } from "../../../Components/UploadFile/upload";
import { useFormik } from "formik";
import LoadingPage from "../../../Components/LoadingDialog/LoadingPage";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import TeachingProfileSection from "./Component/TeachingProfileSection";
import dayjs from "dayjs";

import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import CloseIcon from "@mui/icons-material/Close";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import GroupsIcon from "@mui/icons-material/Groups";
import ScheduleIcon from "@mui/icons-material/Schedule";
import SchoolIcon from "@mui/icons-material/School";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddIcon from "@mui/icons-material/Add";
import EventNoteIcon from "@mui/icons-material/EventNote";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import BarChartIcon from "@mui/icons-material/BarChart";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import LockResetIcon from "@mui/icons-material/LockReset";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import LaptopMacOutlinedIcon from "@mui/icons-material/LaptopMacOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import StaffPortalCredentialDialog from "./Component/StaffPortalCredentialDialog";

// Subject → Grades teaching assignment payload (from the by-subject endpoint).
interface SubjectAssignmentGrade {
  grade_id: number;
  grade_name: string;
  subject_grade_id: number;
  assigned: boolean;
}
interface SubjectAssignment {
  subject_id: number;
  subject_name: string;
  grades: SubjectAssignmentGrade[];
}

// Accent palette used to colour subject cards in the Assign Teaching modal.
const SUBJECT_COLORS = ["#6366f1", "#0ea5e9", "#22c55e", "#f59e0b", "#ec4899", "#8b5cf6", "#14b8a6", "#ef4444"];

// ════════════════════════════════════════════════════════════════
// Reusable Components
// ════════════════════════════════════════════════════════════════

const SummaryCard: React.FC<{
  label: string; value: string | number; icon: React.ReactNode; color: string;
}> = ({ label, value, icon, color }) => (
  <Box sx={{
    bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)",
    p: { xs: 1.5, md: 2.25 }, display: "flex", alignItems: "center", gap: 1.75,
    boxShadow: "0 1px 3px rgba(0,0,0,0.03)",
    transition: "box-shadow 0.15s",
    "&:hover": { boxShadow: "0 3px 10px rgba(0,0,0,0.05)" },
  }}>
    <Box sx={{
      width: 46, height: 46, borderRadius: "13px",
      bgcolor: alpha(color, 0.07), display: "flex", alignItems: "center", justifyContent: "center",
      color, flexShrink: 0, "& svg": { fontSize: 23 },
    }}>
      {icon}
    </Box>
    <Box>
      <Typography sx={{ fontSize: 26, fontWeight: 800, color, lineHeight: 1, letterSpacing: "-0.03em" }}>
        {value}
      </Typography>
      <Typography sx={{ fontSize: 11, fontWeight: 500, color: "text.secondary", mt: 0.3, letterSpacing: "0.01em" }}>
        {label}
      </Typography>
    </Box>
  </Box>
);

const SectionCard: React.FC<{
  children: React.ReactNode; title: string; icon: React.ReactNode; action?: React.ReactNode; noPadding?: boolean;
  id?: string; onTitleClick?: () => void; active?: boolean;
}> = ({ children, title, icon, action, noPadding, id, onTitleClick, active }) => {
  const theme = useTheme();
  return (
    <Box id={id} sx={{
      bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)",
      boxShadow: "0 1px 3px rgba(0,0,0,0.03)", overflow: "hidden", scrollMarginTop: 80,
      ...(active ? { boxShadow: `0 0 0 2px ${alpha(theme.palette.primary.main, 0.35)}` } : {}),
    }}>
      <Box sx={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        px: 2.5, py: 1.5, borderBottom: "1px solid rgba(0,0,0,0.05)",
      }}>
        <Box
          {...(onTitleClick ? { role: "button", tabIndex: 0, "aria-pressed": !!active,
            onClick: onTitleClick,
            onKeyDown: (e: React.KeyboardEvent) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onTitleClick(); } } } : {})}
          sx={{
            display: "flex", alignItems: "center", gap: 1, minWidth: 0,
            ...(onTitleClick ? { cursor: "pointer", borderRadius: "8px", px: 0.5, mx: -0.5, "&:hover .section-title": { textDecoration: "underline" } } : {}),
          }}
        >
          <Box sx={{ color: theme.palette.primary.main, display: "flex", "& svg": { fontSize: 17 } }}>{icon}</Box>
          <Typography className="section-title" sx={{ fontSize: 13.5, fontWeight: 700, letterSpacing: "-0.01em" }}>{title}</Typography>
        </Box>
        {action}
      </Box>
      <Box sx={{ p: noPadding ? 0 : 2.5 }}>{children}</Box>
    </Box>
  );
};

const DetailRow: React.FC<{ label: string; value: string; chip?: boolean; chipColor?: string }> = ({ label, value, chip, chipColor }) => (
  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", py: 0.75 }}>
    <Typography sx={{ fontSize: 12, color: "text.secondary" }}>{label}</Typography>
    {chip ? (
      <Chip label={value} size="small" sx={{
        height: 22, fontSize: 10.5, fontWeight: 600,
        bgcolor: alpha(chipColor || "#22c55e", 0.08), color: chipColor || "#22c55e",
      }} />
    ) : (
      <Typography sx={{ fontSize: 12.5, fontWeight: 600 }}>{value}</Typography>
    )}
  </Box>
);

// ════════════════════════════════════════════════════════════════
// Teaching Assignments Section
// ════════════════════════════════════════════════════════════════

const SUBJECT_PALETTE = ["#6366f1", "#0ea5e9", "#22c55e", "#f59e0b", "#ef4444", "#8b5cf6", "#ec4899", "#14b8a6"];

const TeachingAssignmentsSection: React.FC<{
  teachingAssignments: { gradeId: number; gradeName: string; subjects: string[]; subjectGradeIds: number[] }[];
  weekClasses: any[];
  subjectNameMap: Map<number, string>;
  gradeNameMap: Map<number, string>;
  openNewAssignment: () => void;
  openEditAssignment: (gradeId: number) => void;
  removeAssignment: (gradeId: number) => void;
}> = ({ teachingAssignments, weekClasses, subjectNameMap, gradeNameMap, openNewAssignment, openEditAssignment, removeAssignment }) => {
  const theme = useTheme();

  // Group by subject → grades
  const subjectList = useMemo(() => {
    const groups = new Map<string, { subjectName: string; grades: { gradeId: number; gradeName: string; subjectGradeIds: number[] }[] }>();
    teachingAssignments.forEach((g) => {
      g.subjects.forEach((subjectName) => {
        const existing = groups.get(subjectName);
        const gradeEntry = { gradeId: g.gradeId, gradeName: g.gradeName, subjectGradeIds: g.subjectGradeIds };
        if (existing) {
          if (!existing.grades.find((gr) => gr.gradeId === g.gradeId)) existing.grades.push(gradeEntry);
        } else {
          groups.set(subjectName, { subjectName, grades: [gradeEntry] });
        }
      });
    });
    return Array.from(groups.values());
  }, [teachingAssignments]);

  // Compute student counts per grade from weekly classes
  const gradeStudentCounts = useMemo(() => {
    const counts = new Map<string, number>();
    weekClasses.forEach((cls: any) => {
      const ids: number[] = cls.select_grade_subject_ids || cls.schedule?.assign_class?.select_grade_subject_ids || [];
      const studentCount = cls.assignStudent?.length || cls.number_of_student || 0;
      ids.forEach((id: number) => {
        const gn = gradeNameMap.get(id);
        const sn = subjectNameMap.get(id);
        if (gn && sn) {
          const key = `${sn}::${gn}`;
          counts.set(key, (counts.get(key) || 0) + studentCount);
        }
      });
    });
    return counts;
  }, [weekClasses, gradeNameMap, subjectNameMap]);

  // Collapsible state — first expanded, rest collapsed
  const [expanded, setExpanded] = useState<Set<string>>(new Set(subjectList.length > 0 ? [subjectList[0].subjectName] : []));
  const toggle = (name: string) => setExpanded((prev) => {
    const next = new Set(prev);
    if (next.has(name)) next.delete(name); else next.add(name);
    return next;
  });

  const totalSubjects = subjectList.length;
  const totalClasses = subjectList.reduce((s, sub) => s + sub.grades.length, 0);

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      {/* Section Header */}
      <Box sx={{
        display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2,
      }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box sx={{
            width: 34, height: 34, borderRadius: "10px",
            bgcolor: alpha(theme.palette.primary.main, 0.08),
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <MenuBookIcon sx={{ fontSize: 18, color: theme.palette.primary.main }} />
          </Box>
          <Box>
            <Typography sx={{ fontSize: 15, fontWeight: 700, letterSpacing: "-0.02em", lineHeight: 1.2 }}>
              Teaching Assignments
            </Typography>
            {totalSubjects > 0 && (
              <Typography sx={{ fontSize: 11.5, color: "text.secondary", mt: 0.1 }}>
                {totalSubjects} {totalSubjects === 1 ? "Subject" : "Subjects"} · {totalClasses} {totalClasses === 1 ? "Class" : "Classes"}
              </Typography>
            )}
          </Box>
        </Box>
        <Button size="small" variant="contained" startIcon={<AddIcon sx={{ fontSize: "14px !important" }} />}
          onClick={openNewAssignment}
          sx={{ textTransform: "none", fontSize: 12, fontWeight: 600, borderRadius: "10px", boxShadow: "none", height: 32, px: 2 }}>
          Assign
        </Button>
      </Box>

      {/* Subject cards */}
      {subjectList.length === 0 ? (
        <Box sx={{
          bgcolor: "#fff", borderRadius: "14px", border: "1px solid rgba(0,0,0,0.06)",
          boxShadow: "0 1px 3px rgba(0,0,0,0.03)", textAlign: "center", py: 5, px: 3,
        }}>
          <AutoStoriesOutlinedIcon sx={{ fontSize: 36, color: "rgba(0,0,0,0.08)", mb: 1.5 }} />
          <Typography sx={{ fontSize: 14, fontWeight: 600, color: "text.primary", mb: 0.5 }}>No teaching assignments</Typography>
          <Typography sx={{ fontSize: 12, color: "text.secondary", mb: 2 }}>Assign subjects and grades to this teacher to get started</Typography>
          <Button size="small" variant="outlined" startIcon={<AddIcon />} onClick={openNewAssignment}
            sx={{ textTransform: "none", fontSize: 12, borderRadius: "10px", borderColor: "rgba(0,0,0,0.12)" }}>
            Assign Teaching
          </Button>
        </Box>
      ) : (
        <Grid container spacing={2}>
          {subjectList.map((subj, si) => {
            const color = SUBJECT_PALETTE[si % SUBJECT_PALETTE.length];
            const isOpen = expanded.has(subj.subjectName);
            const totalStudents = subj.grades.reduce((s, g) =>
              s + (gradeStudentCounts.get(`${subj.subjectName}::${g.gradeName}`) || 0), 0);

            return (
              <Grid item xs={12} md={6} lg={4} key={subj.subjectName}>
                <Box sx={{
                  bgcolor: "#fff", borderRadius: "14px",
                  border: `1px solid ${alpha(color, 0.15)}`,
                  boxShadow: "0 1px 3px rgba(0,0,0,0.03)",
                  overflow: "hidden", transition: "box-shadow 0.15s, border-color 0.15s",
                  "&:hover": { boxShadow: "0 3px 12px rgba(0,0,0,0.06)", borderColor: alpha(color, 0.3) },
                }}>
                  {/* Subject header — clickable */}
                  <Box onClick={() => toggle(subj.subjectName)} sx={{
                    display: "flex", alignItems: "center", gap: 1.5, px: 2.5, py: 1.75,
                    cursor: "pointer", userSelect: "none",
                    borderBottom: isOpen ? `1px solid ${alpha(color, 0.1)}` : "none",
                    bgcolor: alpha(color, 0.03),
                  }}>
                    <Box sx={{
                      width: 36, height: 36, borderRadius: "10px",
                      bgcolor: alpha(color, 0.12), display: "flex", alignItems: "center", justifyContent: "center",
                      flexShrink: 0,
                    }}>
                      <MenuBookIcon sx={{ fontSize: 18, color }} />
                    </Box>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography sx={{ fontSize: 14, fontWeight: 700, color: "text.primary", lineHeight: 1.2 }}>
                        {subj.subjectName}
                      </Typography>
                      <Typography sx={{ fontSize: 11, color: "text.secondary", mt: 0.15 }}>
                        {subj.grades.length} {subj.grades.length === 1 ? "Grade" : "Grades"}
                        {totalStudents > 0 ? ` · ${totalStudents} Students` : ""}
                      </Typography>
                    </Box>
                    {isOpen
                      ? <ExpandLessIcon sx={{ fontSize: 20, color: "text.disabled" }} />
                      : <ExpandMoreIcon sx={{ fontSize: 20, color: "text.disabled" }} />}
                  </Box>

                  {/* Grade list — collapsible */}
                  <Collapse in={isOpen}>
                    <Box sx={{ py: 0.5 }}>
                      {subj.grades.map((grade, gi) => {
                        const studentCount = gradeStudentCounts.get(`${subj.subjectName}::${grade.gradeName}`) || 0;
                        return (
                          <Box key={grade.gradeId} sx={{
                            display: "flex", alignItems: "center", justifyContent: "space-between",
                            px: 2.5, py: 1.25,
                            borderBottom: gi < subj.grades.length - 1 ? "1px solid rgba(0,0,0,0.04)" : "none",
                            transition: "background 0.1s",
                            "&:hover": { bgcolor: alpha(color, 0.02) },
                            "&:hover .grade-actions": { opacity: 1 },
                          }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                              <Box sx={{
                                width: 8, height: 8, borderRadius: "50%",
                                bgcolor: alpha(color, 0.4), flexShrink: 0,
                              }} />
                              <Typography sx={{ fontSize: 13, fontWeight: 600, color: "text.primary" }}>
                                {grade.gradeName}
                              </Typography>
                              {studentCount > 0 && (
                                <Chip label={`${studentCount}`} size="small"
                                  icon={<GroupsIcon sx={{ fontSize: "11px !important", color: "inherit !important" }} />}
                                  sx={{
                                    height: 20, fontSize: 10, fontWeight: 600,
                                    bgcolor: alpha(color, 0.08), color,
                                    "& .MuiChip-label": { px: 0.5 },
                                  }} />
                              )}
                            </Box>
                            <Box className="grade-actions" sx={{ display: "flex", gap: 0.25, opacity: 0, transition: "opacity 0.15s" }}>
                              <IconButton size="small" onClick={(e) => { e.stopPropagation(); openEditAssignment(grade.gradeId); }}
                                sx={{ width: 26, height: 26, color: "text.disabled", "&:hover": { color: theme.palette.primary.main, bgcolor: alpha(theme.palette.primary.main, 0.06) } }}>
                                <EditOutlinedIcon sx={{ fontSize: 14 }} />
                              </IconButton>
                              <IconButton size="small" onClick={(e) => { e.stopPropagation(); removeAssignment(grade.gradeId); }}
                                sx={{ width: 26, height: 26, color: "text.disabled", "&:hover": { color: "#ef4444", bgcolor: alpha("#ef4444", 0.06) } }}>
                                <DeleteOutlineIcon sx={{ fontSize: 14 }} />
                              </IconButton>
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  </Collapse>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      )}
    </Box>
  );
};

// ════════════════════════════════════════════════════════════════
// Main Component
// ════════════════════════════════════════════════════════════════

const Index = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  // Staff Profile is reachable by staff-role users viewing themselves
  // (the Staff Portal dashboard's "My Schedule" quick action navigates
  // here for the acting staff). The three "Add Class" buttons on this
  // page must route staff to the auth-locked /staff-portal/classes/create
  // page rather than the admin StaffPicker form.
  const createClassPath = useCreateClassPath();
  const { showErrorMessage, showMessage, showInfoMessage } = useNotifier();
  const { id: staffId } = useParams<{ id: string }>();
  const [fetchTodaySession] = useGetStaffTodaySessionMutation();

  // Quick Actions "Mark Attendance": open the per-session attendance page
  // for today's current/next session, else fall back to the global list.
  const handleQuickMarkAttendance = async () => {
    try {
      const res: any = await fetchTodaySession(Number(staffId)).unwrap();
      const sid = res?.data?.session_id;
      if (sid) {
        navigate(
          `/class-sessions/${sid}/attendance?return_url=${encodeURIComponent(
            `/team-history/${staffId}`
          )}`
        );
        return;
      }
      showErrorMessage("No sessions scheduled today for this staff member.");
    } catch (e: any) {
      showErrorMessage(
        e?.data?.message || "No sessions scheduled today for this staff member."
      );
    }
  };

  // ── Shared page filter state (survives refresh via ?view=) ──
  const [searchParams, setSearchParams] = useSearchParams();
  // Two URL surfaces: `?view=` (in-place summary-pill highlight) and
  // `?tab=ClassSchedules` (dedicated Class Schedules tab that replaces the
  // dashboard). We normalise both aliases so the ClassSchedules tab wins if
  // either is present.
  const classSchedulesTabActive = isClassSchedulesTab(searchParams);
  const activeView: StaffView | "" = classSchedulesTabActive
    ? CLASS_SCHEDULES_VIEW
    : parseView(searchParams.get("view"));
  // Weekly Teaching Schedule mode — independent URL param so the top pills
  // never silently flip the planner (and so refreshing the page preserves an
  // explicitly-chosen Week view). Default = calendar (this is the primary
  // thing staff visit the page for).
  const scheduleView: ScheduleView = parseScheduleView(searchParams.get(SCHEDULE_VIEW_PARAM));
  const selectScheduleView = (v: ScheduleView) => {
    const next = new URLSearchParams(searchParams);
    // Calendar is the default → omit the param to keep the URL clean.
    if (v === "calendar") next.delete(SCHEDULE_VIEW_PARAM);
    else next.set(SCHEDULE_VIEW_PARAM, v);
    setSearchParams(next, { replace: true });
  };
  const selectView = (v: StaffView) => {
    const next = new URLSearchParams(searchParams);
    const toggleOff = activeView === v;

    // Class Schedules is a full-page tab (not a summary highlight) — it uses
    // its own `?tab=ClassSchedules` URL surface, and any lingering `?view=`
    // param would spuriously highlight one of the dashboard pills.
    if (v === CLASS_SCHEDULES_VIEW) {
      next.delete("view");
      if (toggleOff) next.delete("tab");
      else next.set("tab", CLASS_SCHEDULES_TAB_PARAM);
      next.delete(SCHEDULE_VIEW_PARAM);
      setSearchParams(next, { replace: true });
      if (!toggleOff) {
        setTimeout(() => document.getElementById("staff-class-schedules-tab")?.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
      }
      return;
    }

    // Any other pill implicitly leaves the Class Schedules tab.
    next.delete("tab");
    if (toggleOff) next.delete("view");
    else next.set("view", v);
    // Keep the planner mode in sync when the user clicks the Week / This Month
    // pill: the pill and the planner toggle share intent, so pressing "This
    // Week" should switch the planner to Week and vice-versa. Any other pill
    // (Today, Students, Subjects, Classes) leaves the planner untouched.
    if (v === "week") next.set(SCHEDULE_VIEW_PARAM, "week");
    else if (v === "calendar") next.delete(SCHEDULE_VIEW_PARAM);
    setSearchParams(next, { replace: true });
    const targetId = toggleOff ? "" : viewTargetId(v);
    if (targetId) {
      // Let the URL/highlight state settle, then scroll the section into view.
      setTimeout(() => document.getElementById(targetId)?.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
    }
  };

  // Weekly planner sub-view (week grid vs monthly calendar) derives from the
  // same shared ?view= state — the toggle and the top filters stay in sync.
  const { userHasRight } = useUser();
  const canEditSchedule = userHasRight(Privileges.ClassScheduleEdit);
  const canMarkAttendance = userHasRight(Privileges.AttendanceView);

  const [openResetPassword, setOpenResetPassword] = useState(false);
  const [openImage, setOpenImage] = useState(false);
  const [selectedEmpImg, setSelectedEmpImg] = useState("");
  const [selectedImage, setSelectedImage] = useState<File | undefined>(undefined);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<ITeam | null>(null);

  const [newCompany, { isLoading: saveIsLoading }] = useCreateTeamImageMutation();
  const { data, isError, refetch: refetchProfile } = useGetTeamQuery({ searchText: "", id: String(staffId) });
  // Single source of truth for teaching counts + assignments (fixes the 4-vs-7
  // mismatch: subjects/classes/students from active templates, day counts from
  // occurrences).
  const { data: teachingProfileData, isError: isTeachingError, refetch: refetchTeaching } = useGetStaffTeachingProfileQuery({ staffId: String(staffId) });
  const tpCounts: any = (teachingProfileData as any)?.data?.counts ?? {};
  const { data: positionData } = useGetPositionQuery({ searchText: "" });

  const staffData = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) return data.data[0] as ITeam;
    return null;
  }, [data]);

  const { data: departmentData } = useGetDepartmentQuery({ searchText: "" });
  const { data: locationData, refetch: refetchLocations } = useGetallLocationQuery({ searchText: "" });
  const { data: cityData } = useGetallEnumSearchQuery({ searchText: "", enum_type: "city" });
  const { data: provinceEnumData } = useGetallEnumSearchQuery({ searchText: "", enum_type: "province" });
  const { data: countryEnumData } = useGetallEnumSearchQuery({ searchText: "", enum_type: "country" });

  // Staff dashboard stats (includes per-staff class counts, active students)
  const { data: dashboardStatsData, refetch: refetchDashboardStats } = useGetStaffDashboardStatsQuery({});

  // Today's classes for this staff
  const todayStr = dayjs().format("YYYY-MM-DD");
  const weekStart = dayjs().startOf("week").format("YYYY-MM-DD");
  const weekEnd = dayjs().endOf("week").format("YYYY-MM-DD");
  const { data: todayClassesData, refetch: refetchTodayClasses } = useGetAssignClassEmpGetAllCalederQuery(
    staffId ? { startDate: todayStr, endDate: todayStr, empid: String(staffId) } : skipToken
  );
  const { data: weekClassesData, refetch: refetchWeekClasses } = useGetAssignClassEmpGetAllCalederQuery(
    staffId ? { startDate: weekStart, endDate: weekEnd, empid: String(staffId) } : skipToken
  );

  // Compute stats from dashboard data for this specific staff member
  const staffStats = useMemo(() => {
    if (!dashboardStatsData?.data || !staffId) return null;
    const allStaff = (dashboardStatsData.data as any)?.staff;
    if (!Array.isArray(allStaff)) return null;
    return allStaff.find((s: any) => String(s.id) === String(staffId)) || null;
  }, [dashboardStatsData, staffId]);

  // Subject/grade assignments and student data for schedule detail
  const { data: assignClassData, refetch: refetchAssignClasses } = useGetallAssignClassesQuery({ searchText: "" });
  const { data: studentAllData } = useGetallStudentQuery({ searchText: "", id: "" });

  const todayClasses = useMemo(() => {
    if (!todayClassesData?.data || !Array.isArray(todayClassesData.data)) return [];
    return todayClassesData.data as any[];
  }, [todayClassesData]);

  const weekClasses = useMemo(() => {
    if (!weekClassesData?.data || !Array.isArray(weekClassesData.data)) return [];
    return weekClassesData.data as any[];
  }, [weekClassesData]);

  // Maps for resolving subject/grade names from select_grade_subject_ids
  const subjectNameMap = useMemo(() => {
    const map = new Map<number, string>();
    const list = (assignClassData?.data ?? []) as ISubjectGradeAssign[];
    list.forEach((item) => map.set(item.id, item.subject_name));
    return map;
  }, [assignClassData]);

  const gradeNameMap = useMemo(() => {
    const map = new Map<number, string>();
    const list = (assignClassData?.data ?? []) as ISubjectGradeAssign[];
    list.forEach((item) => map.set(item.id, item.grade_name));
    return map;
  }, [assignClassData]);

  // Map for resolving student names/images
  const studentMap = useMemo(() => {
    const map = new Map<number, { name: string; image: string }>();
    const list = (Array.isArray(studentAllData?.data) ? studentAllData!.data : []) as IStudent[];
    list.forEach((s) => {
      const name = `${s.first_name || ""} ${s.last_name || ""}`.trim();
      map.set(s.id, { name, image: s.image || "" });
    });
    return map;
  }, [studentAllData]);

  const positionMap = useMemo(() => {
    const map = new Map<number, string>();
    ((positionData?.data ?? []) as IPosition[]).forEach((p) => map.set(p.id, p.positionName));
    return map;
  }, [positionData]);

  const departmentMap = useMemo(() => {
    const map = new Map<number, string>();
    ((departmentData?.data ?? []) as IDepartment[]).forEach((d) => map.set(d.id, d.departmentName));
    return map;
  }, [departmentData]);

  const locationMap = useMemo(() => {
    const map = new Map<number, string>();
    ((locationData?.data ?? []) as IStudentLocation[]).forEach((l) => map.set(l.id, l.location_name || l.location_address));
    return map;
  }, [locationData]);

  const enumMap = useMemo(() => {
    const map = new Map<number, string>();
    const cities = (Array.isArray(cityData?.data) ? cityData!.data : []) as IEnumType[];
    const provinces = (Array.isArray(provinceEnumData?.data) ? provinceEnumData!.data : []) as IEnumType[];
    const countries = (Array.isArray(countryEnumData?.data) ? countryEnumData!.data : []) as IEnumType[];
    [...cities, ...provinces, ...countries].forEach((e) => map.set(e.id, e.enum_value));
    return map;
  }, [cityData, provinceEnumData, countryEnumData]);

  // Portal access user account
  const shouldFetchUser = !!staffData?.userPerentTableId;
  const { data: userPerenData } = useGetUserAdminOnyQuery(
    shouldFetchUser ? { searchText: "", id: String(staffData?.userPerentTableId) } : skipToken
  );
  const portalUser = useMemo(() => {
    if (userPerenData && Array.isArray(userPerenData.data) && userPerenData.data.length > 0)
      return userPerenData.data[0] as IUserAdmin;
    return null;
  }, [userPerenData]);

  const { data: roleData } = useGetUserRoleQuery({ searchText: "" });
  const portalRoleName = useMemo(() => {
    if (!portalUser || !roleData?.data) return null;
    const roles = (roleData.data ?? []) as any[];
    return roles.find((r: any) => String(r.id) === String(portalUser.user_role))?.roleName || null;
  }, [portalUser, roleData]);

  const [togglePortal, { isLoading: isToggling }] = useToggleStaffPortalAccessMutation();

  // ── Staff Portal Access — new resolver-backed data + mutations ────
  const { data: portalAccessResp, refetch: refetchPortal } = useGetStaffPortalAccessQuery(
    { staffId: String(staffId) },
    { skip: !staffId }
  );
  const portalBlock: any = (portalAccessResp as any)?.data?.portal ?? null;
  const portalStatus: string = portalBlock?.status ?? "no_login";
  const [createStaffPortalAccount, { isLoading: creatingPortal }] = useCreateStaffPortalAccountMutation();
  const [sendPortalInvitation,     { isLoading: sendingInvite }]  = useSendStaffPortalInvitationMutation();
  const [sendPasswordReset,        { isLoading: sendingReset }]   = useSendStaffPasswordResetMutation();
  const [suspendPortal,            { isLoading: suspending }]     = useSuspendStaffPortalAccessMutation();
  const [enablePortal,             { isLoading: enabling }]       = useEnableStaffPortalAccessMutation();
  const [suspendConfirmOpen, setSuspendConfirmOpen] = useState(false);
  // Admin-visible create / reset flow (spec §3–§7 + §11). The dialog
  // is a single component that walks the admin through a mode-picker
  // form → success-with-one-time-credentials. `credentialResult`
  // holds the plaintext `temporary_password` returned by the BE for
  // the lifetime of the dialog; never persisted, never re-fetched.
  const [credDialogOpen, setCredDialogOpen] = useState(false);
  const [credDialogMode, setCredDialogMode] = useState<"create" | "reset">("create");
  const [credDialogSubmitting, setCredDialogSubmitting] = useState(false);
  const [credentialResult, setCredentialResult] = useState<string | null>(null);

  const staffFullName = useMemo(() => {
    const first = (data as any)?.data?.teamFirstName || "";
    const last  = (data as any)?.data?.teamLastName || "";
    return `${first} ${last}`.trim() || "this staff member";
  }, [data]);

  const runPortalAction = async (label: string, fn: () => Promise<any>) => {
    try {
      const res = await fn();
      if (res?.status) {
        // Mail-bearing actions (Login instructions, Password reset) return
        // a `delivery` field so the UI can tell a real external send apart
        // from an intentional local capture. Non-mail portal actions
        // (enable/suspend) don't carry `delivery` and continue to show a
        // plain success toast.
        if (res.delivery === "captured" || res.delivery === "queued" || res.delivery === "suppressed") {
          showInfoMessage(res.message || "External email delivery is disabled in this environment.");
        } else {
          showMessage(res.message || `${label} succeeded.`);
        }
        refetchPortal();
      } else {
        showErrorMessage(res?.message || `${label} failed.`);
      }
    } catch (e: any) {
      showErrorMessage(e?.data?.message || `${label} failed.`);
    }
  };

  // Teaching assignments
  const { data: gradeAssignData, refetch: refetchAssignments } = useGetGradesAssignStaffQuery(
    { id: String(staffId) },
    { skip: !staffId }
  );
  const { data: subjectData } = useGetallSubjectQuery({ searchText: "" });
  const [saveAssignment, { isLoading: savingAssignment }] = useCreateSubjectGradeAssignStaddMutation();

  // ── Teaching assignment modal (Subject → Grades) ──
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  // subject_id → selected grade_ids
  const [subjectGradeSelections, setSubjectGradeSelections] = useState<Record<number, number[]>>({});
  const [expandedModalSubjects, setExpandedModalSubjects] = useState<Set<number>>(new Set());

  const { data: subjectAssignResp, refetch: refetchSubjectAssign } = useGetStaffSubjectAssignmentsQuery(
    { id: Number(staffId) },
    { skip: !staffId }
  );
  const subjectAssignments = useMemo<SubjectAssignment[]>(
    () => (Array.isArray(subjectAssignResp?.data) ? (subjectAssignResp!.data as unknown as SubjectAssignment[]) : []),
    [subjectAssignResp]
  );
  const [saveSubjectAssignment, { isLoading: savingSubjectAssignment }] = useSaveStaffSubjectAssignmentsMutation();

  const subjectMap = useMemo(() => {
    const map = new Map<number, string>();
    const list = Array.isArray(subjectData?.data) ? (subjectData!.data as ISubject[]) : [];
    list.forEach((s) => map.set(s.id, s.subject_name));
    return map;
  }, [subjectData]);

  const teachingAssignments = useMemo(() => {
    const grades = Array.isArray(gradeAssignData?.data) ? (gradeAssignData!.data as any[]) : [];
    return grades
      .map((g) => {
        const assignedSubjects = (g.subjects || [])
          .filter((s: any) => s.is_assigned_to_staff);
        if (assignedSubjects.length === 0) return null;
        return {
          gradeId: g.id,
          gradeName: g.grade,
          subjects: assignedSubjects.map((s: any) => subjectMap.get(s.subject_id) || "Subject").filter(Boolean) as string[],
          subjectGradeIds: assignedSubjects.map((s: any) => s.id) as number[],
        };
      })
      .filter(Boolean) as { gradeId: number; gradeName: string; subjects: string[]; subjectGradeIds: number[] }[];
  }, [gradeAssignData, subjectMap]);

  // Seed the modal from current assignments, then open it.
  const openAssignModal = () => {
    const init: Record<number, number[]> = {};
    subjectAssignments.forEach((s) => {
      const sel = s.grades.filter((g) => g.assigned).map((g) => g.grade_id);
      if (sel.length) init[s.subject_id] = sel;
    });
    setSubjectGradeSelections(init);
    // Expand every subject by default — show the whole matrix in one view.
    setExpandedModalSubjects(new Set(subjectAssignments.map((s) => s.subject_id)));
    setAssignModalOpen(true);
  };

  // Card callbacks — both "Assign" and per-subject edit open the unified modal.
  const openNewAssignment = () => openAssignModal();
  const openEditAssignment = (_gradeId: number) => openAssignModal();

  const toggleModalGrade = (subjectId: number, gradeId: number) => {
    setSubjectGradeSelections((prev) => {
      const cur = prev[subjectId] || [];
      const next = cur.includes(gradeId) ? cur.filter((g) => g !== gradeId) : [...cur, gradeId];
      return { ...prev, [subjectId]: next };
    });
  };

  const toggleModalSubjectExpanded = (subjectId: number) => {
    setExpandedModalSubjects((prev) => {
      const next = new Set(prev);
      if (next.has(subjectId)) next.delete(subjectId);
      else next.add(subjectId);
      return next;
    });
  };

  const totalSelectedGrades = useMemo(
    () => Object.values(subjectGradeSelections).reduce((s, arr) => s + arr.length, 0),
    [subjectGradeSelections]
  );

  // Remove all assignments for a grade (per-grade quick action on the card).
  const removeAssignment = async (gradeId: number) => {
    try {
      const r = await saveAssignment({
        staff_id: Number(staffId),
        get_update_array: [{ grade_id: gradeId, subject_grade_id: [] }],
      }).unwrap();
      if (r.status) {
        showMessage("Assignment removed");
        refetchAssignments();
        refetchSubjectAssign();
      } else {
        showErrorMessage(r.message || "Failed to remove");
      }
    } catch { showErrorMessage("Failed to remove assignment"); }
  };

  // Save the whole Subject → Grades matrix in one call.
  const handleSaveAssignment = async () => {
    const subjects = subjectAssignments.map((s) => ({
      subject_id: s.subject_id,
      grade_ids: subjectGradeSelections[s.subject_id] || [],
    }));
    try {
      const r: any = await saveSubjectAssignment({ staff_id: Number(staffId), subjects }).unwrap();
      if (r.status) {
        if (Array.isArray(r.blocked) && r.blocked.length) {
          showErrorMessage(r.message || "Some subject/grade pairs are used by a class and were kept.");
        } else {
          showMessage(r.message || "Teaching assignments updated");
        }
        setAssignModalOpen(false);
        refetchAssignments();
        refetchSubjectAssign();
      } else {
        showErrorMessage(r.message || "Failed to save");
      }
    } catch { showErrorMessage("Failed to save teaching assignments"); }
  };

  // ── Image handling ──
  const resizeImage = (file: File, maxW: number, maxH: number): Promise<File> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (ev) => {
        const img = new Image();
        img.src = ev.target?.result as string;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          let w = img.width, h = img.height;
          if (w > h) { if (w > maxW) { h *= maxW / w; w = maxW; } } else { if (h > maxH) { w *= maxH / h; h = maxH; } }
          canvas.width = w; canvas.height = h;
          canvas.getContext("2d")?.drawImage(img, 0, 0, w, h);
          canvas.toBlob((blob) => blob ? resolve(new File([blob], file.name, { type: file.type })) : reject(), file.type);
        };
      };
    });

  const handleImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) { showErrorMessage("File must be an image."); return; }
    if (file.size > 5 * 1024 * 1024) { showErrorMessage("Max 5 MB."); return; }
    try { setSelectedImage(await resizeImage(file, 500, 500)); } catch { showErrorMessage("Failed to process."); }
  };

  const formik = useFormik({
    initialValues: { id: String(staffId) || "", teamImg: staffData?.teamImg || "" },
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        let teamImg = staffData?.teamImg;
        if (selectedImage) teamImg = (await uploadImage(selectedImage)) || "";
        const r = await newCompany({ id: Number(values.id), teamImg }).unwrap();
        if (r.status) { showMessage(r.message); setOpenImage(false); setSelectedImage(undefined); } else showErrorMessage(r.message);
      } catch { showErrorMessage("Something went wrong"); }
    },
  });

  const formikRemoved = useFormik({
    initialValues: { id: String(staffId) || "", teamImg: "" },
    enableReinitialize: true,
    onSubmit: async () => {
      try {
        const r = await newCompany({ id: Number(staffId), teamImg: "" }).unwrap();
        if (r.status) { showMessage(r.message); setOpenImage(false); setSelectedImage(undefined); } else showErrorMessage(r.message);
      } catch { showErrorMessage("Something went wrong"); }
    },
  });

  const [deleteCategory] = useDeleteTeamMutation();
  const handleDelete = async (id: string) => {
    try {
      const r = await deleteCategory(id).unwrap();
      if (r.status) { showMessage("Deleted"); setOpenDeleteCategory(false); navigate("/team/list"); }
      else showErrorMessage("Failed");
    } catch { showErrorMessage("Failed"); }
  };

  // Resolve location names from location_id (can be single int or JSON array)
  const locationNames = useMemo(() => {
    const locId = staffData?.location_id;
    if (!locId) return [];
    try {
      const parsed = JSON.parse(locId);
      if (Array.isArray(parsed)) {
        return parsed.map((id: number) => locationMap.get(id)).filter(Boolean) as string[];
      }
    } catch {}
    const name = locationMap.get(Number(locId));
    return name ? [name] : [];
  }, [staffData?.location_id, locationMap]);

  // Resolve address parts
  const addressParts = useMemo(() => {
    const addr = staffData?.address;
    if (!addr) return "";
    const parts: string[] = [];
    if (addr.unit_number) parts.push(`Unit ${addr.unit_number}`);
    if (addr.street) parts.push(addr.street);
    if (addr.city_id) { const c = enumMap.get(addr.city_id); if (c) parts.push(c); }
    if (addr.province_id) { const p = enumMap.get(addr.province_id); if (p) parts.push(p); }
    if (addr.postal_code) parts.push(addr.postal_code);
    if (addr.country_id) { const c = enumMap.get(addr.country_id); if (c) parts.push(c); }
    return parts.join(", ");
  }, [staffData?.address, enumMap]);

  // Format teaching mode for display
  const teachingMode = useMemo(() => {
    if (!staffData?.mode) return "";
    return staffData.mode.split(",").map((m: string) => m === "InPerson" ? "In Person" : m).join(", ");
  }, [staffData?.mode]);

  // Expanded schedule cards (must be before early returns for hooks rules)
  const expandedScheduleCards = useMemo(() => {
    const palette = ["#6366f1", "#0ea5e9", "#22c55e", "#f59e0b", "#ef4444", "#8b5cf6", "#ec4899", "#14b8a6"];
    const scm = new Map<string, string>(); let ci2 = 0;
    const cards: { key: string; subject: string; grade: string; startTime: string; endTime: string; students: any[]; studentCount: number; locName: string | null; classMode: string; color: string }[] = [];
    todayClasses.forEach((cls: any, idx: number) => {
      const sched = cls.schedule || cls; const ac = sched?.assign_class || cls.assign_class;
      const st = sched?.startTime || cls.startTime || ""; const et = sched?.endTime || cls.endTime || "";
      const ids: number[] = cls.select_grade_subject_ids || ac?.select_grade_subject_ids || [];
      const studs: any[] = cls.assignStudent || []; const sc = cls.number_of_student ?? studs.length;
      const lid = ac?.location_id ?? sched?.location_id; const ln = lid ? (locationMap.get(Number(lid)) || null) : null;
      const cm = ac?.class_mode || sched?.class_mode || "";
      const pa = new Set<string>();
      ids.forEach((id: number) => {
        const sn = subjectNameMap.get(id) || ""; const gn = gradeNameMap.get(id) || "";
        if (!sn && !gn) return; const pk = `${sn}||${gn}`; if (pa.has(pk)) return; pa.add(pk);
        if (sn && !scm.has(sn)) { scm.set(sn, palette[ci2 % palette.length]); ci2++; }
        cards.push({ key: `${idx}-${id}`, subject: sn || "Class", grade: gn, startTime: st, endTime: et, students: studs, studentCount: sc, locName: ln, classMode: cm, color: scm.get(sn) || "#6366f1" });
      });
      if (pa.size === 0) cards.push({ key: `${idx}-fb`, subject: "Class", grade: "", startTime: st, endTime: et, students: studs, studentCount: sc, locName: ln, classMode: cm, color: "#6366f1" });
    });
    cards.sort((a, b) => a.startTime.localeCompare(b.startTime));
    return cards;
  }, [todayClasses, subjectNameMap, gradeNameMap, locationMap]);

  const nextClassKey = useMemo(() => {
    const n = dayjs(); for (const c of expandedScheduleCards) { if (n.isBefore(dayjs(`${todayStr} ${c.startTime}`))) return c.key; } return null;
  }, [expandedScheduleCards, todayStr]);

  const uniqueSubjectCount = useMemo(() => {
    const s = new Set<string>(); teachingAssignments.forEach((g) => g.subjects.forEach((sub) => s.add(sub))); return s.size;
  }, [teachingAssignments]);

  const [scheduleExpanded, setScheduleExpanded] = useState(false);
  const SCHEDULE_COMPACT_LIMIT = 4;

  // Today's Schedule status filter — client-side, defaults to All. Reset when
  // the staff profile changes so filters from a previous teacher never bleed
  // into the new profile.
  type TodayFilter = "all" | "upcoming" | "completed";
  const [todayFilter, setTodayFilter] = useState<TodayFilter>("all");
  React.useEffect(() => {
    setTodayFilter("all");
  }, [staffId]);

  // ── Full-page loading orchestration ──────────────────────────────────────
  // The profile is a mosaic of ~7 RTK queries. Rendering the shell while any
  // of them are still resolving is what caused zero counts to flash and one
  // staff's calendar to appear briefly under another's name. Instead we hold
  // the whole content region behind a single branded loader until every
  // *critical* query has data for the CURRENT staffId, then latch that in
  // state so background refetches (calendar month change, attendance refresh,
  // filter toggles) never re-block the whole page.
  const currentStaffId = String(staffId ?? "");
  // Only the staff record + teaching profile actually gate the hero and
  // identity content. The peripheral widgets (dashboard stats, today /
  // week classes, locations, assigned classes) each already fall back
  // to [] / null in their memos, so we let them populate progressively
  // instead of holding the whole shell behind their slowest response.
  // This is what caused the profile to sit on the branded loader for
  // several seconds when e.g. the assign-classes list was slow.
  const criticalDataReady = !!data && !!teachingProfileData;
  const criticalError = isError || isTeachingError;

  const [initialReadyStaffId, setInitialReadyStaffId] = useState<string | null>(null);
  // Clear the "ready" latch and jump the viewport back to the top whenever the
  // route staffId changes, so David Ratno's month never sits under Galaxy
  // Deena's profile even for a paint.
  React.useEffect(() => {
    setInitialReadyStaffId((prev) => (prev === currentStaffId ? prev : null));
    if (typeof window !== "undefined") window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [currentStaffId]);
  // Latch READY the moment every critical query has data for THIS staff. Once
  // latched, subsequent isFetching cycles are treated as background refetches.
  React.useEffect(() => {
    if (criticalDataReady && initialReadyStaffId !== currentStaffId) {
      setInitialReadyStaffId(currentStaffId);
    }
  }, [criticalDataReady, currentStaffId, initialReadyStaffId]);

  const isInitialPageLoading = initialReadyStaffId !== currentStaffId && !criticalError;

  if (criticalError) {
    return (
      <Box
        role="alert"
        aria-live="assertive"
        sx={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", p: 3 }}
      >
        <Box sx={{ maxWidth: 420, textAlign: "center", bgcolor: "#fff", borderRadius: "16px", border: "1px solid rgba(15,23,42,0.06)", p: 4 }}>
          <Typography sx={{ fontSize: 18, fontWeight: 800, mb: 0.5 }}>Unable to load staff profile</Typography>
          <Typography sx={{ fontSize: 13, color: "text.secondary", mb: 2.5 }}>
            Some staff information or schedule data could not be loaded.
          </Typography>
          <Stack direction="row" spacing={1} justifyContent="center">
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                // Refetch every critical query; local queries with cached data
                // will short-circuit and only the failed ones will hit the API.
                refetchProfile();
                refetchTeaching();
                refetchDashboardStats();
                refetchTodayClasses();
                refetchWeekClasses();
                refetchLocations();
                refetchAssignClasses();
              }}
              sx={{ textTransform: "none", borderRadius: "9px", boxShadow: "none", fontWeight: 700 }}
            >
              Retry
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={() => navigate("/team/list")}
              sx={{ textTransform: "none", borderRadius: "9px", borderColor: "rgba(15,23,42,0.12)", color: "text.secondary", fontWeight: 700 }}
            >
              Back to Staff List
            </Button>
          </Stack>
        </Box>
      </Box>
    );
  }

  if (isInitialPageLoading || !staffData) {
    // One consistent branded loader covers the entire profile content area.
    // The outer Box takes role=status + aria-live=polite so screen readers
    // announce loading once (rather than every rerender), and aria-busy=true
    // signals that nothing beneath it is interactive yet.
    return (
      <Box
        role="status"
        aria-busy="true"
        aria-live="polite"
        aria-label="Loading staff profile"
        sx={{ minHeight: "60vh", display: "flex", flexDirection: "column", justifyContent: "center" }}
      >
        <LoadingPage open title="Loading staff profile…" />
        <Typography sx={{ mt: -2, textAlign: "center", fontSize: 11.5, color: "text.disabled" }}>
          Preparing schedule and teaching information
        </Typography>
      </Box>
    );
  }

  const fullName = `${staffData.teamFirstName || ""} ${staffData.middle_name || ""} ${staffData.teamLastName || ""}`.trim();
  const initials = `${(staffData.teamFirstName || "").charAt(0)}${(staffData.teamLastName || "").charAt(0)}`.toUpperCase() || "S";
  const positionName = staffData.teamPositionId ? positionMap.get(staffData.teamPositionId) : null;
  const departmentName = staffData.teamDepartmentId ? departmentMap.get(staffData.teamDepartmentId) : null;
  const metaParts: string[] = [];
  if (positionName) metaParts.push(positionName);
  if (teachingMode) metaParts.push(teachingMode);
  if (locationNames.length) metaParts.push(locationNames.join(", "));
  const metaLine = metaParts.join(" · ");

  // Return-url back-nav. Only shown when the profile was opened from
  // a class-detail route (guarded so an arbitrary `?return_url=...` can
  // never point outside the app or to unrelated pages). Class-detail
  // routes have the shape `/class-schedules/{numericId}`.
  const rawReturnUrl = searchParams.get("return_url") || "";
  const classDetailBack = (() => {
    if (!rawReturnUrl.startsWith("/class-schedules/")) return null;
    const rest = rawReturnUrl.slice("/class-schedules/".length);
    const classId = rest.split(/[/?#]/)[0];
    if (!/^\d+$/.test(classId)) return null;
    return { to: `/class-schedules/${classId}`, label: "Back to Class Details" };
  })();

  return (
    <Box aria-busy="false">
      {classDetailBack && (
        <Box sx={{ mb: 1.25 }}>
          <Button
            component={RouterLink}
            to={classDetailBack.to}
            size="small"
            startIcon={<ArrowBackIcon sx={{ fontSize: "16px !important" }} />}
            sx={{
              textTransform: "none",
              color: "text.secondary",
              fontSize: 12.5,
              fontWeight: 600,
              px: 1.25,
              height: 32,
              borderRadius: "8px",
              "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.08), color: "primary.main" },
            }}
          >
            {classDetailBack.label}
          </Button>
        </Box>
      )}
      {/* ══════════ HERO PROFILE BAR ══════════ */}
      <Box sx={{
        bgcolor: "#fff", borderRadius: "16px", border: "1px solid rgba(0,0,0,0.06)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.04)", mb: 2, overflow: "hidden",
      }}>
        <Box sx={{ px: { xs: 2, md: 3 }, py: 2, display: "flex", alignItems: "center", gap: 2.5, flexWrap: { xs: "wrap", md: "nowrap" } }}>
          {/* Avatar */}
          <Box sx={{ position: "relative", flexShrink: 0 }}>
            <Avatar src={staffData.teamImg || undefined} sx={{
              width: 56, height: 56, fontSize: 20, fontWeight: 700, cursor: "pointer",
              background: staffData.teamImg ? undefined : `linear-gradient(135deg, ${theme.palette.primary.main}, ${alpha(theme.palette.primary.main, 0.6)})`,
              color: "#fff",
            }} onClick={() => { setSelectedEmpImg(staffData.teamImg || ""); setOpenImage(true); }}>
              {staffData.teamImg ? null : initials}
            </Avatar>
            <IconButton size="small" onClick={() => { setSelectedEmpImg(staffData.teamImg || ""); setOpenImage(true); }}
              sx={{ position: "absolute", bottom: -1, right: -1, bgcolor: theme.palette.primary.main, color: "#fff", width: 20, height: 20, "&:hover": { bgcolor: theme.palette.primary.dark }, boxShadow: "0 1px 3px rgba(0,0,0,0.25)" }}>
              <CameraAltIcon sx={{ fontSize: 10 }} />
            </IconButton>
          </Box>

          {/* Identity */}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.25 }}>
              <Typography sx={{ fontSize: 18, fontWeight: 800, letterSpacing: "-0.02em", lineHeight: 1.2 }}>{fullName}</Typography>
              <Chip label="Active" size="small" sx={{ height: 20, fontSize: 10, fontWeight: 700, bgcolor: alpha("#22c55e", 0.1), color: "#16a34a" }} />
            </Box>
            <Typography sx={{ fontSize: 12, color: "text.secondary" }}>{metaLine}</Typography>
            <Stack direction="row" spacing={2} sx={{ mt: 0.5 }}>
              {staffData.teamEmail && <Stack direction="row" spacing={0.5} alignItems="center"><EmailIcon sx={{ fontSize: 12, color: "text.disabled" }} /><Typography sx={{ fontSize: 11.5, color: "text.secondary" }}>{staffData.teamEmail}</Typography></Stack>}
              {staffData.teamMobileNum && <Stack direction="row" spacing={0.5} alignItems="center"><PhoneIcon sx={{ fontSize: 12, color: "text.disabled" }} /><Typography sx={{ fontSize: 11.5, color: "text.secondary" }}>{formatPhoneNumberForDisplay(staffData.teamMobileNum)}</Typography></Stack>}
            </Stack>
          </Box>

          {/* Actions */}
          <Stack direction="row" spacing={0.75} sx={{ flexShrink: 0 }}>
            <Button variant="outlined" size="small" startIcon={<EditOutlinedIcon sx={{ fontSize: "13px !important" }} />}
              onClick={() => navigate(`/team/edit/${staffId}`)}
              sx={{ textTransform: "none", fontSize: 11, borderColor: "rgba(0,0,0,0.1)", color: "text.secondary", height: 30, px: 1.5 }}>
              Edit
            </Button>
            <IconButton size="small" onClick={() => { setCoursingToDelete(staffData); setOpenDeleteCategory(true); }}
              sx={{ color: "text.disabled", width: 30, height: 30, border: "1px solid rgba(0,0,0,0.08)", "&:hover": { color: "#ef4444", borderColor: alpha("#ef4444", 0.3) } }}>
              <DeleteOutlineIcon sx={{ fontSize: 15 }} />
            </IconButton>
          </Stack>
        </Box>

        {/* Integrated stat pills — clickable filter buttons (shared ?view= state) */}
        <Box sx={{
          px: { xs: 1.5, md: 3 }, py: 1, borderTop: "1px solid rgba(0,0,0,0.04)",
          bgcolor: "rgba(0,0,0,0.01)",
          display: "flex", gap: { xs: 1, md: 1.5 },
          flexWrap: { xs: "nowrap", md: "wrap" }, overflowX: { xs: "auto", md: "visible" },
        }}>
          {[
            { label: "Today", view: "today" as StaffView, value: tpCounts.today ?? 0, color: "#6366f1" },
            { label: "This Week", view: "week" as StaffView, value: tpCounts.this_week ?? 0, color: "#0ea5e9" },
            { label: "This Month", view: "calendar" as StaffView, value: tpCounts.this_month ?? 0, color: "#22c55e" },
            { label: "Students", view: "students" as StaffView, value: tpCounts.students ?? 0, color: "#f59e0b" },
            { label: "Subjects", view: "subjects" as StaffView, value: tpCounts.subjects ?? 0, color: "#8b5cf6" },
            // "Classes" pill opens the dedicated Class Schedules tab
            // (spec §2A). Backed by the same active-template count that the
            // tab's card list is built from, so the number never diverges.
            { label: "Classes", view: CLASS_SCHEDULES_VIEW as StaffView, value: tpCounts.classes ?? 0, color: "#ec4899" },
          ].map((s) => {
            const active = activeView === s.view;
            return (
              <Box
                key={s.label} component="button" type="button"
                aria-pressed={active} onClick={() => selectView(s.view)}
                sx={{
                  display: "flex", alignItems: "center", gap: 0.6, flexShrink: 0,
                  cursor: "pointer", font: "inherit", borderRadius: "10px", px: 1, py: 0.6,
                  border: "1px solid", borderColor: active ? alpha(s.color, 0.5) : "transparent",
                  bgcolor: active ? alpha(s.color, 0.1) : "transparent",
                  transition: "background-color .15s, border-color .15s",
                  "&:hover": { bgcolor: alpha(s.color, 0.07) },
                  "&:focus-visible": { outline: `2px solid ${alpha(s.color, 0.5)}`, outlineOffset: 1 },
                }}
              >
                <Typography sx={{ fontSize: 16, fontWeight: 800, color: s.color, letterSpacing: "-0.02em" }}>{s.value}</Typography>
                <Typography sx={{ fontSize: 10.5, color: active ? s.color : "text.secondary", fontWeight: active ? 700 : 500 }}>{s.label}</Typography>
              </Box>
            );
          })}
        </Box>
      </Box>

      {/* ══════════ 2-COLUMN MAIN LAYOUT ══════════ */}
      <Grid container spacing={2}>
        {/* ── LEFT COLUMN ── */}
        <Grid item lg={9} md={12} xs={12}>
          {classSchedulesTabActive ? (
            /* Dedicated Class Schedules tab — replaces the entire dashboard
               column so users see a single focused view of the staff member's
               assigned class SCHEDULE PATTERNS (never dated occurrences). */
            <ClassSchedulesTab
              staffId={String(staffId)}
              canEditSchedule={canEditSchedule}
              onAddClass={() => navigate(`${createClassPath()}?${buildCreateReturnSearch(`/team-history/${staffId}`, "staff-profile")}`)}
            />
          ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

            {/* Weekly Teaching Schedule — moved above Today's Schedule because
                staff mainly open this page to check a teacher's classes and
                availability. Defaults to the monthly Calendar view; the URL
                param `?schedule_view=week` preserves an explicit Week choice
                across refresh. */}
            {/* Weekly-schedule popup action routing:
                • View Class      → the class-level details page keyed on the
                                    recurring class id (assign_classes.id).
                                    Previously navigated to the Edit-Class
                                    form ("/assign/classes/create/emp/…"),
                                    which was wrong — that's the CREATE/EDIT
                                    surface, not the read-only details view.
                • Edit Schedule   → the recurring-pattern editor keyed on the
                                    same assign_classes.id. Previously
                                    navigated with `occurrence_id`, which is
                                    a class_occurrences.id that has no row in
                                    assign_classes — that's the source of the
                                    "Class schedule not found" screenshot.
                • Mark Attendance → occurrence-scoped attendance page, keyed
                                    on occurrence_id (a specific dated
                                    session). Previously navigated with no id
                                    at all, dropping context.
                Every destination preserves `return_url` back to this staff
                profile so browser Back + the destination-page "Back" button
                both land here. */}
            <WeeklySchedulePlanner
              key={`planner-${staffId}`}
              staffId={String(staffId)}
              mode={scheduleView}
              onModeChange={selectScheduleView}
              highlight={isWeeklyView(activeView) || isCalendarView(activeView)}
              onViewClass={(classId) => navigate(`/class-schedules/${classId}?return_url=${encodeURIComponent(`/team-history/${staffId}`)}`)}
              onEditSchedule={(classId) => {
                // Edit Schedule must open the SHARED Create/Edit form
                // (Pages/Classes/Edit renders <ClassForm mode="edit" />),
                // NOT the legacy /class-schedules/:id/edit page which used a
                // separate simplified UI. Return-URL points back to this
                // profile with the Class Schedules tab active so the user
                // sees their edit reflected immediately.
                const returnUrl = `/team-history/${staffId}?tab=ClassSchedules`;
                navigate(`/classes/${classId}/edit?return_url=${encodeURIComponent(returnUrl)}`);
              }}
              onMarkAttendance={(occurrenceId) => navigate(occurrenceId
                ? `/class-sessions/${occurrenceId}/attendance?return_url=${encodeURIComponent(`/team-history/${staffId}`)}`
                : "/attendance-record/list")}
              onViewFullSchedule={() => navigate(`/class-schedule/list?staff_id=${staffId}`)}
              canEditSchedule={canEditSchedule}
              canMarkAttendance={canMarkAttendance}
            />

            {/* Today's Schedule — responsive card grid. Each card is one time
                slot (multiple classes at the same start/end time collapse into
                the same card) built from occurrence-level data. Chronological,
                completed slots first, upcoming below; the "Next" upcoming card
                gets a slightly stronger emphasis. Card click / Enter / Space
                opens the admin class-details page which resolves the correct
                upcoming occurrence for that class. */}
            <SectionCard
              id={SECTION_IDS.today}
              title={`Today's Schedule — ${dayjs().format("ddd, MMM D")}`}
              icon={<SchoolIcon />}
              onTitleClick={() => selectView("today")}
              active={activeView === "today"}
              action={
                <Stack direction="row" spacing={0.75} alignItems="center">
                  <Button
                    size="small"
                    variant="text"
                    onClick={() => {
                      // Staff-specific schedule destination must stay on this
                      // profile with the Class Schedules tab activated — not
                      // the global class-sessions list. `tab=ClassSchedules`
                      // is the canonical param the profile reads.
                      selectView(CLASS_SCHEDULES_VIEW);
                    }}
                    sx={{ textTransform: "none", fontSize: 10.5, height: 26, color: "text.secondary", px: 1 }}
                  >
                    View Day Schedule
                  </Button>
                  <Button
                    size="small"
                    variant="contained"
                    startIcon={<AddIcon sx={{ fontSize: "13px !important" }} />}
                    onClick={() => navigate(`${createClassPath()}?${buildCreateReturnSearch(`/team-history/${staffId}`, "staff-profile")}`)}
                    sx={{ textTransform: "none", fontSize: 10.5, height: 26, boxShadow: "none", borderRadius: "7px", px: 1.5 }}
                  >
                    Add Class
                  </Button>
                </Stack>
              }
              noPadding
            >
              {todayClasses.length > 0 ? (() => {
                interface TimeSlotCard {
                  timeKey: string;
                  startTime: string;
                  endTime: string;
                  gradeSubjects: { grade: string; subjects: string[] }[];
                  students: any[];
                  studentCount: number;
                  locName: string | null;
                  classMode: string;
                  classType: string;
                  classId: number | null;
                  // Canonical class_occurrences.id for THIS date+time slot,
                  // used by View Attendance to deep-link into the exact
                  // occurrence's attendance page. Null when the DTO row
                  // came from a schedule-only source with no occurrence
                  // resolved (falls back to the list route in that case).
                  occurrenceId: number | null;
                  isOngoing: boolean;
                  isCompleted: boolean;
                  isNext: boolean;
                }
                const slotMap = new Map<string, {
                  startTime: string; endTime: string;
                  gradeSubjects: Map<string, Set<string>>;
                  students: any[]; studentCount: number;
                  locName: string | null; classMode: string;
                  classType: string; classId: number | null;
                  occurrenceId: number | null;
                }>();

                todayClasses.forEach((cls: any) => {
                  const sched = cls.schedule || cls;
                  const ac = sched?.assign_class || cls.assign_class;
                  const st = sched?.startTime || cls.startTime || "";
                  const et = sched?.endTime || cls.endTime || "";
                  const tk = `${st}-${et}`;
                  const ids: number[] = cls.select_grade_subject_ids || ac?.select_grade_subject_ids || [];
                  const studs: any[] = cls.assignStudent || [];
                  const sc = cls.number_of_student ?? studs.length;
                  const lid = ac?.location_id ?? sched?.location_id;
                  const ln = lid ? (locationMap.get(Number(lid)) || null) : null;
                  const cm = ac?.class_mode || sched?.class_mode || "";
                  const ct = ac?.class_type || cls.class_type || "";
                  const cid = Number(cls.class_id ?? ac?.id ?? sched?.class_id) || null;
                  const oid = Number(cls.occurrence_id ?? cls.occurrenceId) || null;

                  let slot = slotMap.get(tk);
                  if (!slot) {
                    slot = { startTime: st, endTime: et, gradeSubjects: new Map(), students: [], studentCount: 0, locName: ln, classMode: cm, classType: ct, classId: cid, occurrenceId: oid };
                    slotMap.set(tk, slot);
                  }
                  const existingIds = new Set(slot.students.map((s: any) => s.student_id));
                  studs.forEach((s: any) => { if (!existingIds.has(s.student_id)) { slot!.students.push(s); existingIds.add(s.student_id); } });
                  slot.studentCount = slot.students.length || Math.max(slot.studentCount, sc);
                  if (!slot.locName && ln) slot.locName = ln;
                  if (!slot.classId && cid) slot.classId = cid;
                  if (!slot.occurrenceId && oid) slot.occurrenceId = oid;

                  ids.forEach((id: number) => {
                    const gn = gradeNameMap.get(id); const sn = subjectNameMap.get(id);
                    if (!gn || !sn) return;
                    let subs = slot!.gradeSubjects.get(gn);
                    if (!subs) { subs = new Set(); slot!.gradeSubjects.set(gn, subs); }
                    subs.add(sn);
                  });
                });

                // Compute state (completed / ongoing / upcoming) chronologically,
                // then mark the first upcoming slot as "Next". This is captured
                // once per render — a live countdown would need a ticking clock,
                // which the spec explicitly does not require.
                const now2 = dayjs();
                const rawSlots = Array.from(slotMap.values())
                  .sort((a, b) => a.startTime.localeCompare(b.startTime))
                  .map((slot) => {
                    const cStart = dayjs(`${todayStr} ${slot.startTime}`);
                    const cEnd = dayjs(`${todayStr} ${slot.endTime}`);
                    const isOngoing = now2.isAfter(cStart) && now2.isBefore(cEnd);
                    const isCompleted = now2.isAfter(cEnd);
                    return { slot, isOngoing, isCompleted };
                  });
                let foundNext = false;
                const timeSlots: TimeSlotCard[] = rawSlots.map(({ slot, isOngoing, isCompleted }) => {
                  const isNext = !foundNext && !isCompleted && !isOngoing;
                  if (isNext) foundNext = true;
                  const gradeSubjects: { grade: string; subjects: string[] }[] = [];
                  slot.gradeSubjects.forEach((subs, grade) => gradeSubjects.push({ grade, subjects: Array.from(subs).sort() }));
                  gradeSubjects.sort((a, b) => a.grade.localeCompare(b.grade));
                  return {
                    timeKey: `${slot.startTime}-${slot.endTime}`,
                    startTime: slot.startTime,
                    endTime: slot.endTime,
                    gradeSubjects,
                    students: slot.students,
                    studentCount: slot.studentCount,
                    locName: slot.locName,
                    classMode: slot.classMode,
                    classType: slot.classType,
                    classId: slot.classId,
                    occurrenceId: slot.occurrenceId,
                    isOngoing, isCompleted, isNext,
                  };
                });

                // Filter counts drive the tabs — computed against the FULL list
                // so the "All 5 · Upcoming 2 · Completed 3" counts don't shift
                // when the user toggles a filter.
                const completedCount = timeSlots.filter((s) => s.isCompleted).length;
                const upcomingCount = timeSlots.filter((s) => !s.isCompleted).length;
                const visibleSlots = timeSlots.filter((s) => {
                  if (todayFilter === "completed") return s.isCompleted;
                  if (todayFilter === "upcoming") return !s.isCompleted;
                  return true;
                });

                // Split into groups so completed classes stack at the top and
                // the "Next" upcoming card leads the Upcoming group — never
                // interleaved with old completed slots in confusing order.
                const completedGroup = visibleSlots.filter((s) => s.isCompleted);
                const upcomingGroup = visibleSlots.filter((s) => !s.isCompleted);

                const fmt12 = (t: string) => {
                  if (!t) return "";
                  const [hh, mm] = t.split(":").map((n) => Number(n));
                  if (Number.isNaN(hh) || Number.isNaN(mm)) return t;
                  const h = hh % 12 || 12; const ampm = hh >= 12 ? "PM" : "AM";
                  return `${h}:${String(mm).padStart(2, "0")} ${ampm}`;
                };
                const duration = (s: string, e: string) => {
                  if (!s || !e) return "";
                  const mins = dayjs(`${todayStr} ${e}`).diff(dayjs(`${todayStr} ${s}`), "minute");
                  if (mins <= 0) return "";
                  const h = Math.floor(mins / 60); const m = mins % 60;
                  return h > 0 && m > 0 ? `${h}h ${m}m` : h > 0 ? `${h} hour${h > 1 ? "s" : ""}` : `${m} min`;
                };
                const isOnlineMode = (m: string) => (m || "").toLowerCase() === "online";
                const modeLabel = (m: string) => (isOnlineMode(m) ? "Online" : m ? "In Person" : "");

                // Status → color/label. Completed uses green (light tint,
                // never a dark full green bg). Upcoming uses amber; Next Class
                // is a slightly stronger amber so it stands out inside the
                // Upcoming group. In Progress uses teal so it's clearly not
                // "just an upcoming class".
                const statusFor = (s: TimeSlotCard) => {
                  if (s.isOngoing) return { label: "In Progress", color: "#0d9488", bg: alpha("#0d9488", 0.1) };
                  if (s.isCompleted) return { label: "Completed", color: "#16a34a", bg: alpha("#16a34a", 0.12) };
                  if (s.isNext) return { label: "Next Class", color: "#b45309", bg: alpha("#f59e0b", 0.18) };
                  return { label: "Upcoming", color: "#b45309", bg: alpha("#f59e0b", 0.12) };
                };
                const accentFor = (s: TimeSlotCard) => {
                  if (s.isOngoing) return "#0d9488";
                  if (s.isCompleted) return "#16a34a";
                  // Both Next Class and plain Upcoming use amber; Next gets the
                  // stronger border alpha + soft shadow below to make it lead.
                  return "#f59e0b";
                };
                const cardBgFor = (s: TimeSlotCard) => {
                  // Light tinted background per status — subtle, never
                  // aggressive. Next Class gets a bit more amber to stand out.
                  if (s.isOngoing) return alpha("#0d9488", 0.03);
                  if (s.isCompleted) return alpha("#16a34a", 0.04);
                  if (s.isNext) return alpha("#f59e0b", 0.07);
                  return alpha("#f59e0b", 0.04);
                };

                const openOccurrence = (s: TimeSlotCard) => {
                  if (!s.classId) return;
                  // Admin class-details page resolves the correct occurrence
                  // for the class (today's session lands on the upcoming one).
                  navigate(`/check-staff/classes/list/${s.classId}`);
                };

                const renderCard = (slot: TimeSlotCard) => {
                  const st = statusFor(slot);
                  const accent = accentFor(slot);
                  const online = isOnlineMode(slot.classMode);
                  const primaryGroups = slot.gradeSubjects.slice(0, 3);
                  const extraGroups = slot.gradeSubjects.length - primaryGroups.length;
                  const ariaLabel = slot.gradeSubjects.length > 0
                    ? `View class details for ${slot.gradeSubjects.map((g) => `${g.grade} ${g.subjects.join(" and ")}`).join(", ")} from ${fmt12(slot.startTime)} to ${fmt12(slot.endTime)}.`
                    : `View class details from ${fmt12(slot.startTime)} to ${fmt12(slot.endTime)}.`;

                  return (
                    <Box
                      key={slot.timeKey}
                      role="button"
                      tabIndex={0}
                      aria-label={ariaLabel}
                      onClick={() => openOccurrence(slot)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          openOccurrence(slot);
                        }
                      }}
                      sx={{
                        display: "flex", flexDirection: "column", gap: 0.9,
                        minWidth: 0,
                        bgcolor: cardBgFor(slot), borderRadius: "12px",
                        border: `1px solid ${alpha(accent, slot.isNext ? 0.4 : 0.2)}`,
                        borderLeft: `4px solid ${accent}`,
                        boxShadow: slot.isNext ? `0 2px 10px ${alpha(accent, 0.16)}` : "0 1px 2px rgba(15,23,42,0.03)",
                        p: 1.5, cursor: slot.classId ? "pointer" : "default",
                        transition: "box-shadow 0.15s, border-color 0.15s, transform 0.15s",
                        outline: "none",
                        "&:hover": slot.classId ? {
                          boxShadow: `0 6px 18px ${alpha(accent, 0.18)}`,
                          borderColor: alpha(accent, 0.5),
                        } : {},
                        "&:focus-visible": {
                          boxShadow: `0 0 0 3px ${alpha(accent, 0.35)}`,
                          borderColor: accent,
                        },
                      }}
                    >
                      {/* Header — time + status. Compact — smaller icon and
                          font so 4 cards can share a row on wide desktop. */}
                      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 0.75 }}>
                        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.5, minWidth: 0 }}>
                          <AccessTimeIcon sx={{ fontSize: 14, color: accent, mt: "3px", flexShrink: 0 }} />
                          <Box sx={{ minWidth: 0 }}>
                            <Typography sx={{ fontSize: 12.5, fontWeight: 800, letterSpacing: "-0.01em", lineHeight: 1.2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {fmt12(slot.startTime)}{slot.endTime ? `–${fmt12(slot.endTime)}` : ""}
                            </Typography>
                            {duration(slot.startTime, slot.endTime) && (
                              <Typography sx={{ fontSize: 10, color: "text.secondary", mt: 0.1 }}>
                                {duration(slot.startTime, slot.endTime)}
                              </Typography>
                            )}
                          </Box>
                        </Box>
                        <Chip
                          label={st.label}
                          size="small"
                          sx={{
                            height: 18, fontSize: 9.5, fontWeight: 700, flexShrink: 0,
                            bgcolor: st.bg, color: st.color,
                            "& .MuiChip-label": { px: 0.65 },
                          }}
                        />
                      </Box>

                      {/* Subjects by Grade — compact chips */}
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.35 }}>
                        {primaryGroups.length === 0 ? (
                          <Typography sx={{ fontSize: 11, color: "text.disabled" }}>Class</Typography>
                        ) : (
                          primaryGroups.map((g) => (
                            <Box key={g.grade} sx={{ display: "flex", alignItems: "flex-start", gap: 0.5, flexWrap: "wrap" }}>
                              <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: "text.primary", minWidth: 48, flexShrink: 0, pt: 0.2 }}>
                                {g.grade}
                              </Typography>
                              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.3 }}>
                                {g.subjects.map((s) => (
                                  <Chip
                                    key={s} label={s} size="small"
                                    sx={{
                                      height: 17, fontSize: 9.5, fontWeight: 600,
                                      bgcolor: "rgba(15,23,42,0.05)", color: "text.primary",
                                      "& .MuiChip-label": { px: 0.6 },
                                    }}
                                  />
                                ))}
                              </Box>
                            </Box>
                          ))
                        )}
                        {extraGroups > 0 && (
                          <Typography sx={{ fontSize: 10, color: "text.secondary", fontWeight: 600 }}>
                            +{extraGroups} more grade{extraGroups > 1 ? "s" : ""}
                          </Typography>
                        )}
                      </Box>

                      {/* Metadata — mode / location (only In Person) / students / class type */}
                      <Box sx={{ display: "flex", flexWrap: "wrap", rowGap: 0.4, columnGap: 1, alignItems: "center" }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.3, color: "text.secondary", minWidth: 0 }}>
                          {online ? <LaptopMacOutlinedIcon sx={{ fontSize: 12 }} /> : <PlaceOutlinedIcon sx={{ fontSize: 12 }} />}
                          <Typography sx={{ fontSize: 10.5, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {online ? "Online" : (slot.locName || modeLabel(slot.classMode) || "In Person")}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.3, color: "text.secondary" }}>
                          <GroupsIcon sx={{ fontSize: 12 }} />
                          <Typography sx={{ fontSize: 10.5, fontWeight: 600 }}>
                            {slot.studentCount} student{slot.studentCount === 1 ? "" : "s"}
                          </Typography>
                        </Box>
                        {slot.classType && (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.3, color: "text.secondary" }}>
                            <CategoryOutlinedIcon sx={{ fontSize: 12 }} />
                            <Typography sx={{ fontSize: 10.5, fontWeight: 600, textTransform: "capitalize" }}>
                              {slot.classType}
                            </Typography>
                          </Box>
                        )}
                      </Box>

                      {/* Actions — compact footer; buttons stop propagation so
                          they don't double-trigger the card click. */}
                      <Box sx={{ display: "flex", gap: 0.5, pt: 0.4, mt: "auto", borderTop: `1px solid ${alpha(accent, 0.15)}` }}>
                        <Button
                          size="small"
                          variant="text"
                          startIcon={<VisibilityOutlinedIcon sx={{ fontSize: "13px !important" }} />}
                          onClick={(e) => { e.stopPropagation(); openOccurrence(slot); }}
                          disabled={!slot.classId}
                          sx={{ textTransform: "none", fontWeight: 700, fontSize: 10.5, borderRadius: "6px", flex: 1, color: "text.primary", py: 0.25, minHeight: 0 }}
                        >
                          View Details
                        </Button>
                        {canMarkAttendance && (
                          <Tooltip
                            title={slot.isCompleted || slot.isOngoing ? "" : "Attendance opens once the class starts"}
                            arrow
                            disableHoverListener={slot.isCompleted || slot.isOngoing}
                          >
                            <span style={{ flex: 1 }}>
                              <Button
                                size="small"
                                variant="text"
                                startIcon={<HowToRegOutlinedIcon sx={{ fontSize: "13px !important" }} />}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  // Deep-link to the exact occurrence's
                                  // attendance page. return_url takes the
                                  // reviewer back to this Staff Profile
                                  // (the sibling Weekly Schedule already
                                  // uses the same pattern via
                                  // onMarkAttendance above). Fall back to
                                  // the school-wide list only when this
                                  // slot has no resolved occurrence yet
                                  // (schedule row for a future/no-op day).
                                  if (slot.occurrenceId) {
                                    const back = encodeURIComponent(`/team-history/${staffId}`);
                                    navigate(`/class-sessions/${slot.occurrenceId}/attendance?return_url=${back}`);
                                  } else {
                                    navigate("/attendance-record/list");
                                  }
                                }}
                                disabled={!slot.isCompleted && !slot.isOngoing}
                                sx={{ textTransform: "none", fontWeight: 700, fontSize: 10.5, borderRadius: "6px", width: "100%", color: accent, py: 0.25, minHeight: 0 }}
                              >
                                {slot.isCompleted ? "View Attendance" : "Attendance"}
                              </Button>
                            </span>
                          </Tooltip>
                        )}
                      </Box>
                    </Box>
                  );
                };

                const filterTab = (key: TodayFilter, label: string, count: number) => (
                  <Box
                    key={key}
                    component="button"
                    type="button"
                    onClick={() => setTodayFilter(key)}
                    aria-pressed={todayFilter === key}
                    sx={{
                      cursor: "pointer", font: "inherit", border: "1px solid",
                      borderColor: todayFilter === key ? theme.palette.primary.main : "rgba(15,23,42,0.1)",
                      bgcolor: todayFilter === key ? alpha(theme.palette.primary.main, 0.08) : "#fff",
                      color: todayFilter === key ? theme.palette.primary.main : "text.secondary",
                      borderRadius: "8px", px: 1.25, py: 0.4, display: "flex", alignItems: "center", gap: 0.5,
                      fontSize: 11.5, fontWeight: 700,
                      transition: "background-color .15s, border-color .15s",
                      "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.06) },
                      "&:focus-visible": { outline: `2px solid ${alpha(theme.palette.primary.main, 0.4)}`, outlineOffset: 1 },
                    }}
                  >
                    {label}
                    <Typography component="span" sx={{ fontSize: 10.5, fontWeight: 800, opacity: 0.75 }}>{count}</Typography>
                  </Box>
                );

                return (
                  <Box sx={{ p: 2 }}>
                    {/* Summary + filter tabs */}
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mb: 1.5 }}>
                      <Typography sx={{ fontSize: 11.5, color: "text.secondary", fontWeight: 600 }}>
                        {timeSlots.length} class{timeSlots.length === 1 ? "" : "es"} · {completedCount} completed · {upcomingCount} upcoming
                      </Typography>
                      <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                        {filterTab("all", "All", timeSlots.length)}
                        {filterTab("upcoming", "Upcoming", upcomingCount)}
                        {filterTab("completed", "Completed", completedCount)}
                      </Box>
                    </Box>

                    {visibleSlots.length === 0 ? (
                      <Box sx={{ textAlign: "center", py: 3, px: 2, borderRadius: "10px", border: "1px dashed rgba(15,23,42,0.12)" }}>
                        <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: "text.secondary" }}>
                          No {todayFilter === "completed" ? "completed" : "upcoming"} classes to show.
                        </Typography>
                      </Box>
                    ) : (
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        {completedGroup.length > 0 && (
                          <Box>
                            {todayFilter === "all" && upcomingGroup.length > 0 && (
                              <Typography sx={{ fontSize: 10.5, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", color: "text.disabled", mb: 0.75 }}>
                                Completed earlier today
                              </Typography>
                            )}
                            <Box sx={{
                              display: "grid",
                              gap: 1.25,
                              // Responsive card density: mobile 1 · tablet 2 ·
                              // wide desktop 3 · extra-wide 4. Cards keep a
                              // min column width so they never squash below a
                              // readable size (min 230px). alignItems:start
                              // stops the grid from stretching all cards to
                              // the tallest one — natural height per card.
                              gridTemplateColumns: {
                                xs: "1fr",
                                sm: "1fr",
                                md: "repeat(2, minmax(0, 1fr))",
                                lg: "repeat(3, minmax(0, 1fr))",
                                xl: "repeat(4, minmax(0, 1fr))",
                              },
                              alignItems: "start",
                            }}>
                              {completedGroup.map(renderCard)}
                            </Box>
                          </Box>
                        )}
                        {upcomingGroup.length > 0 && (
                          <Box>
                            {todayFilter === "all" && completedGroup.length > 0 && (
                              <Typography sx={{ fontSize: 10.5, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", color: "text.disabled", mb: 0.75 }}>
                                Upcoming
                              </Typography>
                            )}
                            <Box sx={{
                              display: "grid",
                              gap: 1.25,
                              // Responsive card density: mobile 1 · tablet 2 ·
                              // wide desktop 3 · extra-wide 4. Cards keep a
                              // min column width so they never squash below a
                              // readable size (min 230px). alignItems:start
                              // stops the grid from stretching all cards to
                              // the tallest one — natural height per card.
                              gridTemplateColumns: {
                                xs: "1fr",
                                sm: "1fr",
                                md: "repeat(2, minmax(0, 1fr))",
                                lg: "repeat(3, minmax(0, 1fr))",
                                xl: "repeat(4, minmax(0, 1fr))",
                              },
                              alignItems: "start",
                            }}>
                              {upcomingGroup.map(renderCard)}
                            </Box>
                          </Box>
                        )}
                      </Box>
                    )}
                  </Box>
                );
              })() : (
                <Box sx={{ textAlign: "center", py: 4, px: 3 }}>
                  <Box sx={{
                    width: 44, height: 44, borderRadius: "12px",
                    bgcolor: alpha(theme.palette.primary.main, 0.08),
                    color: theme.palette.primary.main,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    mx: "auto", mb: 1.25,
                  }}>
                    <CalendarTodayIcon sx={{ fontSize: 20 }} />
                  </Box>
                  <Typography sx={{ fontSize: 14, fontWeight: 700, color: "text.primary", mb: 0.25 }}>No classes scheduled today</Typography>
                  <Typography sx={{ fontSize: 11.5, color: "text.secondary", mb: 2 }}>
                    This staff member has no teaching sessions today.
                  </Typography>
                  <Stack direction="row" spacing={1} justifyContent="center">
                    <Button
                      size="small" variant="contained"
                      startIcon={<AddIcon sx={{ fontSize: "13px !important" }} />}
                      onClick={() => navigate(`${createClassPath()}?${buildCreateReturnSearch(`/team-history/${staffId}`, "staff-profile")}`)}
                      sx={{ textTransform: "none", fontSize: 12, borderRadius: "8px", boxShadow: "none", px: 1.5 }}
                    >
                      Add Class
                    </Button>
                    <Button
                      size="small" variant="outlined"
                      onClick={() => navigate(`/class-schedule/list?staff_id=${staffId}`)}
                      sx={{ textTransform: "none", fontSize: 12, borderRadius: "8px", borderColor: "rgba(15,23,42,0.12)", color: "text.secondary", px: 1.5 }}
                    >
                      View Full Schedule
                    </Button>
                  </Stack>
                </Box>
              )}
            </SectionCard>

            {/* Teaching Assignments — the staff member's Grade → Subject
                teaching capabilities. Not a class list; classes appear in the
                Today, Weekly, and Class Schedule sections. */}
            <TeachingProfileSection
              staffId={String(staffId)}
              staffName={fullName}
            />

            {/* Weekly Progress — Compact strip */}
            <SectionCard title="Progress Overview" icon={<BarChartIcon />}>
              <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                {[
                  { label: "This Week", view: "week" as StaffView, value: weekClasses.length, max: 20, color: "#6366f1" },
                  { label: "This Month", view: "calendar" as StaffView, value: staffStats?.monthlyClassCount ?? 0, max: 80, color: "#22c55e" },
                  { label: "Students", view: "students" as StaffView, value: staffStats?.activeStudentCount ?? 0, max: 30, color: "#0ea5e9" },
                  { label: "Today", view: "today" as StaffView, value: todayClasses.length, max: 8, color: "#f59e0b" },
                ].map((m) => {
                  const pct = Math.min(((typeof m.value === "number" ? m.value : 0) / m.max) * 100, 100);
                  const active = activeView === m.view;
                  return (
                    <Box key={m.label} component="button" type="button" aria-pressed={active} onClick={() => selectView(m.view)}
                      sx={{
                        flex: 1, minWidth: 80, textAlign: "left", font: "inherit", cursor: "pointer",
                        border: "1px solid", borderColor: active ? alpha(m.color, 0.5) : "transparent",
                        bgcolor: active ? alpha(m.color, 0.06) : "transparent",
                        borderRadius: "10px", p: 0.75, transition: "background-color .15s, border-color .15s",
                        "&:hover": { bgcolor: alpha(m.color, 0.05) },
                        "&:focus-visible": { outline: `2px solid ${alpha(m.color, 0.5)}`, outlineOffset: 1 },
                      }}>
                      <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5, mb: 0.5 }}>
                        <Typography sx={{ fontSize: 18, fontWeight: 800, color: m.color, letterSpacing: "-0.02em" }}>{m.value}</Typography>
                        <Typography sx={{ fontSize: 10, color: "text.disabled" }}>/ {m.max}</Typography>
                      </Box>
                      <LinearProgress variant="determinate" value={pct}
                        sx={{ height: 4, borderRadius: 2, bgcolor: alpha(m.color, 0.08), "& .MuiLinearProgress-bar": { bgcolor: m.color, borderRadius: 2 } }} />
                      <Typography sx={{ fontSize: 10, color: "text.secondary", mt: 0.4, fontWeight: 500 }}>{m.label}</Typography>
                    </Box>
                  );
                })}
              </Box>
            </SectionCard>
          </Box>
          )}
        </Grid>

        {/* ── RIGHT SIDEBAR (Sticky) ── */}
        <Grid item lg={3} md={12} xs={12} sx={{ minWidth: { lg: 300 } }}>
          <Box sx={{ position: { lg: "sticky" }, top: { lg: 16 }, display: "flex", flexDirection: "column", gap: 2 }}>

            {/* Quick Actions */}
            <SectionCard title="Quick Actions" icon={<TrendingUpIcon />}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
                <Button fullWidth variant="contained" size="small" startIcon={<CheckCircleOutlineIcon sx={{ fontSize: "16px !important" }} />}
                  onClick={handleQuickMarkAttendance}
                  sx={{ textTransform: "none", fontSize: 12, justifyContent: "flex-start", py: 1, boxShadow: "none", borderRadius: "10px" }}>
                  Mark Attendance
                </Button>
                {[
                  { label: "Teaching Dashboard", icon: <AssignmentIcon />, onClick: () => navigate("/staff-dashboard") },
                  { label: "View Class Sessions", icon: <CalendarTodayIcon />, onClick: () => navigate("/class-schedule/list") },
                  // "Class Schedules" opens the in-page tab (spec §2B) — never
                  // navigates away to the global schedule list.
                  { label: "Class Schedules", icon: <ScheduleIcon />, onClick: () => selectView(CLASS_SCHEDULES_VIEW) },
                ].map((a, i) => (
                  <Button key={i} fullWidth variant="text" size="small"
                    startIcon={React.cloneElement(a.icon as React.ReactElement, { sx: { fontSize: "15px !important" } })}
                    onClick={a.onClick}
                    sx={{ textTransform: "none", fontSize: 12, justifyContent: "flex-start", py: 0.75, color: "text.secondary", borderRadius: "10px", "&:hover": { bgcolor: "rgba(0,0,0,0.03)", color: "text.primary" } }}>
                    {a.label}
                  </Button>
                ))}
              </Box>
            </SectionCard>

            {/* Staff Details — Grouped */}
            <SectionCard title="Staff Details" icon={<PersonOutlineIcon />}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography sx={{ fontSize: 10, fontWeight: 700, color: "text.disabled", textTransform: "uppercase", letterSpacing: "0.06em", mb: 0.5 }}>Contact</Typography>
                {staffData.teamEmail && <DetailRow label="Email" value={staffData.teamEmail} />}
                {staffData.teamMobileNum && <DetailRow label="Phone" value={formatPhoneNumberForDisplay(staffData.teamMobileNum)} />}
                {staffData.teamAltMobileNum && <DetailRow label="Emergency" value={formatPhoneNumberForDisplay(staffData.teamAltMobileNum)} />}
                <Divider sx={{ my: 1 }} />
                <Typography sx={{ fontSize: 10, fontWeight: 700, color: "text.disabled", textTransform: "uppercase", letterSpacing: "0.06em", mb: 0.5 }}>Work</Typography>
                {staffData.teamId && <DetailRow label="Staff ID" value={staffData.teamId} />}
                {departmentName && <DetailRow label="Department" value={departmentName} />}
                {positionName && <DetailRow label="Position" value={positionName} />}
                {teachingMode && <DetailRow label="Mode" value={teachingMode} />}
                <DetailRow label="Status" value="Active" chip chipColor="#22c55e" />
                {(locationNames.length > 0 || addressParts) && (
                  <>
                    <Divider sx={{ my: 1 }} />
                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: "text.disabled", textTransform: "uppercase", letterSpacing: "0.06em", mb: 0.5 }}>Location</Typography>
                    {locationNames.length > 0 && <DetailRow label="Locations" value={locationNames.join(", ")} />}
                    {addressParts && <DetailRow label="Address" value={addressParts} />}
                  </>
                )}
                {(staffData.teamHourlySalary || staffData.teamOtHourlySalary) && (
                  <>
                    <Divider sx={{ my: 1 }} />
                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: "text.disabled", textTransform: "uppercase", letterSpacing: "0.06em", mb: 0.5 }}>Compensation</Typography>
                    {staffData.teamHourlySalary && <DetailRow label="Hourly" value={`$${staffData.teamHourlySalary}/hr`} />}
                    {staffData.teamOtHourlySalary && <DetailRow label="OT Rate" value={`$${staffData.teamOtHourlySalary}/hr`} />}
                  </>
                )}
              </Box>
            </SectionCard>

            {/* ─── Staff Portal Login & Access (spec §3) ────────────── */}
            <SectionCard title="Staff Portal Login & Access" icon={<VpnKeyIcon />}>
              {/* Status chip */}
              {(() => {
                const chipMap: Record<string, { label: string; bg: string; fg: string; dot: string }> = {
                  active:              { label: "Active",             bg: "#dcfce7", fg: "#166534", dot: "#16a34a" },
                  invitation_pending:  { label: "Invitation Pending", bg: "#fef3c7", fg: "#92400e", dot: "#d97706" },
                  suspended:           { label: "Suspended",          bg: "#fee2e2", fg: "#991b1b", dot: "#dc2626" },
                  no_login:            { label: "No Login",           bg: "#eef2ff", fg: "#4338ca", dot: "#6366f1" },
                };
                const chip = chipMap[portalStatus] || chipMap.no_login;
                return (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                    <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: chip.dot }} />
                    <Typography sx={{ fontSize: 12, fontWeight: 800, color: chip.fg, letterSpacing: 0.2 }}>
                      Portal Status: {chip.label}
                    </Typography>
                  </Box>
                );
              })()}

              {/* Metadata block */}
              <Box sx={{ p: 1.25, borderRadius: "8px", bgcolor: "rgba(0,0,0,0.015)", border: "1px solid rgba(0,0,0,0.04)", mb: 1.5 }}>
                {portalBlock?.staff_name && <DetailRow label="Staff" value={portalBlock.staff_name} />}
                {portalBlock?.username && <DetailRow label="Username" value={portalBlock.username} />}
                {portalBlock?.staff_id_label && <DetailRow label="Staff ID" value={portalBlock.staff_id_label} />}
                {portalBlock?.login_email && <DetailRow label="Login Email" value={portalBlock.login_email} />}
                {portalBlock?.role && <DetailRow label="Role" value={portalBlock.role} />}
                {portalBlock?.access_locations?.length > 0 && (
                  <DetailRow label="Locations" value={portalBlock.access_locations.join(", ")} />
                )}
                <DetailRow
                  label="Last Login"
                  value={portalBlock?.last_login_at
                    ? new Date(portalBlock.last_login_at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })
                    : "Never"}
                />
                {portalBlock?.account_created_at && (
                  <DetailRow
                    label="Account Created"
                    value={new Date(portalBlock.account_created_at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}
                  />
                )}
                <DetailRow label="Password" value={portalBlock?.password_is_set ? "Set" : "Not set"} />
                {portalStatus === "suspended" && portalBlock?.suspended_by && (
                  <DetailRow label="Suspended By" value={portalBlock.suspended_by} />
                )}
                {portalStatus === "suspended" && portalBlock?.suspended_at && (
                  <DetailRow
                    label="Suspended On"
                    value={new Date(portalBlock.suspended_at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}
                  />
                )}
              </Box>

              {/* Recent action timestamps */}
              {(portalBlock?.last_reset_sent_at || portalBlock?.last_instructions_sent_at) && (
                <Box sx={{ mb: 1, px: 0.5 }}>
                  {portalBlock?.last_reset_sent_at && (
                    <Typography sx={{ fontSize: 10.5, color: "text.secondary", lineHeight: 1.7 }}>
                      · Password reset sent {new Date(portalBlock.last_reset_sent_at).toLocaleString()}
                    </Typography>
                  )}
                  {portalBlock?.last_instructions_sent_at && (
                    <Typography sx={{ fontSize: 10.5, color: "text.secondary", lineHeight: 1.7 }}>
                      · Login instructions sent {new Date(portalBlock.last_instructions_sent_at).toLocaleString()}
                    </Typography>
                  )}
                </Box>
              )}

              {/* Actions — differ by portal status (spec §14) */}
              <Stack spacing={0.75}>
                {portalStatus === "no_login" && (() => {
                  // Eligibility for creating a staff portal account.
                  // The previous check read `data.data.teamEmail`, but
                  // `data.data` is the ARRAY returned by getTeam
                  // (`data.data[0]` is the staff — see the resolved
                  // `staffData` memo above). So the property was ALWAYS
                  // undefined and the button was permanently disabled
                  // for every no-login staff regardless of whether they
                  // had a valid email. Read from `staffData.teamEmail`
                  // — the same field the UI already displays as
                  // "Login Email".
                  const email = String((staffData as any)?.teamEmail ?? "").trim();
                  const hasEmail = email !== "";
                  const tooltip = !hasEmail
                    ? "Add a login email to this staff record before creating a portal account."
                    : "";
                  return (
                    <Tooltip title={tooltip} arrow disableHoverListener={!tooltip}>
                      <span>
                        <Button
                          fullWidth size="small" variant="contained"
                          startIcon={<VpnKeyIcon sx={{ fontSize: "14px !important" }} />}
                          onClick={() => {
                            setCredDialogMode("create");
                            setCredentialResult(null);
                            setCredDialogOpen(true);
                          }}
                          disabled={creatingPortal || !hasEmail}
                          sx={{ textTransform: "none", fontSize: 12, fontWeight: 700, bgcolor: "#166534", "&:hover": { bgcolor: "#14532d" }, boxShadow: "none", borderRadius: "8px", height: 34 }}
                        >
                          {creatingPortal ? "Creating Account…" : "Create Staff Portal Account"}
                        </Button>
                      </span>
                    </Tooltip>
                  );
                })()}

                {(portalStatus === "active" || portalStatus === "invitation_pending") && (
                  <>
                    <Button
                      fullWidth size="small"
                      startIcon={<LockResetIcon sx={{ fontSize: "14px !important" }} />}
                      onClick={() => {
                        setCredDialogMode("reset");
                        setCredentialResult(null);
                        setCredDialogOpen(true);
                      }}
                      disabled={sendingReset || credDialogSubmitting}
                      sx={{ textTransform: "none", fontSize: 12, fontWeight: 700, bgcolor: "#fef3c7", color: "#92400e", border: "1px solid #fcd34d", "&:hover": { bgcolor: "#fde68a" }, borderRadius: "8px", justifyContent: "flex-start", height: 34 }}
                    >
                      {credDialogSubmitting && credDialogMode === "reset" ? "Resetting…" : "Reset Password"}
                    </Button>
                    <Button
                      fullWidth size="small"
                      startIcon={<VpnKeyIcon sx={{ fontSize: "14px !important" }} />}
                      onClick={() => runPortalAction("Login instructions", () => sendPortalInvitation({ staffId: String(staffId) }).unwrap())}
                      disabled={sendingInvite}
                      sx={{ textTransform: "none", fontSize: 12, fontWeight: 700, bgcolor: "#dbeafe", color: "#1d4ed8", border: "1px solid #93c5fd", "&:hover": { bgcolor: "#bfdbfe" }, borderRadius: "8px", justifyContent: "flex-start", height: 34 }}
                    >
                      {sendingInvite ? "Sending Instructions…" : "Send Login Instructions"}
                    </Button>
                    <Button
                      fullWidth size="small"
                      startIcon={<PowerSettingsNewIcon sx={{ fontSize: "14px !important" }} />}
                      onClick={() => setSuspendConfirmOpen(true)}
                      disabled={suspending}
                      sx={{ textTransform: "none", fontSize: 12, fontWeight: 700, bgcolor: "#fee2e2", color: "#991b1b", border: "1px solid #fca5a5", "&:hover": { bgcolor: "#fecaca" }, borderRadius: "8px", justifyContent: "flex-start", height: 34 }}
                    >
                      {suspending ? "Suspending…" : "Suspend Staff Portal Access"}
                    </Button>
                  </>
                )}

                {portalStatus === "suspended" && (
                  <>
                    <Button
                      fullWidth size="small"
                      startIcon={<FiberManualRecordIcon sx={{ fontSize: "10px !important" }} />}
                      onClick={() => runPortalAction("Enable access", () => enablePortal({ staffId: String(staffId) }).unwrap())}
                      disabled={enabling}
                      sx={{ textTransform: "none", fontSize: 12, fontWeight: 700, bgcolor: "#dcfce7", color: "#166534", border: "1px solid #86efac", "&:hover": { bgcolor: "#bbf7d0" }, borderRadius: "8px", justifyContent: "flex-start", height: 34 }}
                    >
                      {enabling ? "Enabling…" : "Enable Staff Portal Access"}
                    </Button>
                    <Button
                      fullWidth size="small"
                      startIcon={<LockResetIcon sx={{ fontSize: "14px !important" }} />}
                      onClick={() => {
                        setCredDialogMode("reset");
                        setCredentialResult(null);
                        setCredDialogOpen(true);
                      }}
                      disabled={sendingReset || credDialogSubmitting}
                      sx={{ textTransform: "none", fontSize: 12, fontWeight: 700, bgcolor: "#fef3c7", color: "#92400e", border: "1px solid #fcd34d", "&:hover": { bgcolor: "#fde68a" }, borderRadius: "8px", justifyContent: "flex-start", height: 34 }}
                    >
                      {credDialogSubmitting && credDialogMode === "reset" ? "Resetting…" : "Reset Password"}
                    </Button>
                  </>
                )}
              </Stack>
            </SectionCard>

            {/* Suspend confirmation modal */}
            <Dialog open={suspendConfirmOpen} onClose={() => setSuspendConfirmOpen(false)} maxWidth="xs" fullWidth>
              <DialogTitle sx={{ fontWeight: 800 }}>Suspend Staff Portal Access?</DialogTitle>
              <DialogContent>
                <Typography sx={{ fontSize: 13.5, color: "text.secondary", lineHeight: 1.7 }}>
                  <b>{staffFullName}</b> will no longer be able to sign in. Staff profile data,
                  assigned classes, schedules, attendance history, payroll history, and reports
                  will remain unchanged.
                </Typography>
              </DialogContent>
              <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={() => setSuspendConfirmOpen(false)} sx={{ textTransform: "none", fontWeight: 700 }}>Cancel</Button>
                <Button
                  variant="contained"
                  onClick={async () => {
                    setSuspendConfirmOpen(false);
                    await runPortalAction("Suspend access", () => suspendPortal({ staffId: String(staffId) }).unwrap());
                  }}
                  sx={{ textTransform: "none", fontWeight: 700, bgcolor: "#991b1b", "&:hover": { bgcolor: "#7f1d1d" } }}
                >
                  Suspend Access
                </Button>
              </DialogActions>
            </Dialog>

            {/* Admin-visible create / reset dialog with one-time
                temporary-password display. Replaces the earlier
                confirm-only modal by folding auto/manual mode picker
                + secure display into a single component. */}
            <StaffPortalCredentialDialog
              open={credDialogOpen}
              mode={credDialogMode}
              staffName={staffFullName}
              staffIdLabel={(staffData as any)?.teamId ?? null}
              loginEmail={portalBlock?.login_email ?? (staffData as any)?.teamEmail ?? null}
              passwordIsSet={portalBlock?.password_is_set}
              isSubmitting={credDialogSubmitting}
              credential={credentialResult ? { password: credentialResult } : null}
              onClose={() => {
                setCredDialogOpen(false);
                setCredentialResult(null);
                // Refetch so the card reflects password_is_set → true
                // and the new status after a create/reset.
                refetchPortal();
              }}
              onSubmit={async ({ mode, password }) => {
                setCredDialogSubmitting(true);
                try {
                  const payload: any = {
                    staffId: String(staffId),
                    credential_delivery: "display",
                    password_mode: mode,
                    ...(mode === "manual" && password ? { password } : {}),
                  };
                  const fn = credDialogMode === "create" ? createStaffPortalAccount : sendPasswordReset;
                  const res: any = await fn(payload).unwrap();
                  if (!res?.status) {
                    showErrorMessage(res?.message || `Failed to ${credDialogMode === "create" ? "create account" : "reset password"}.`);
                    return;
                  }
                  const temp: string | undefined = res?.temporary_password;
                  if (!temp) {
                    showErrorMessage("Server did not return a temporary password. Please try again.");
                    return;
                  }
                  showMessage(credDialogMode === "create"
                    ? "Staff portal account created successfully."
                    : "Password reset successfully.");
                  setCredentialResult(temp);
                } catch (e: any) {
                  const errs = e?.data?.errors;
                  const firstErr = errs && typeof errs === "object" ? (Object.values(errs)[0] as any)?.[0] : null;
                  showErrorMessage(firstErr || e?.data?.message || e?.message || "Request failed.");
                } finally {
                  setCredDialogSubmitting(false);
                }
              }}
            />

          </Box>
        </Grid>
      </Grid>

      {/* ── Teaching Assignment Modal (Subject → Grades) ── */}
      <Dialog open={assignModalOpen} onClose={() => setAssignModalOpen(false)} maxWidth="md" fullWidth
        PaperProps={{ sx: { borderRadius: "18px", overflow: "hidden" } }}>
        {/* Header */}
        <Box sx={{
          px: 3, pt: 2.75, pb: 2, display: "flex", alignItems: "center", gap: 1.5,
          background: `linear-gradient(180deg, ${alpha(theme.palette.primary.main, 0.06)}, transparent)`,
        }}>
          <Box sx={{
            width: 42, height: 42, borderRadius: "12px", flexShrink: 0,
            bgcolor: alpha(theme.palette.primary.main, 0.1), color: theme.palette.primary.main,
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <SchoolIcon sx={{ fontSize: 22 }} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: 17, fontWeight: 700, letterSpacing: "-0.01em" }}>Assign Teaching</Typography>
            <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
              Choose the grades this staff member teaches for each subject
            </Typography>
          </Box>
          <IconButton size="small" onClick={() => setAssignModalOpen(false)} sx={{ alignSelf: "flex-start" }}>
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>

        {/* Toolbar */}
        {subjectAssignments.length > 0 && (
          <Box sx={{ px: 3, pb: 1.25, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: 11, fontWeight: 700, color: "text.disabled", textTransform: "uppercase", letterSpacing: "0.06em" }}>
              {subjectAssignments.length} Subjects
            </Typography>
            <Button size="small"
              onClick={() => {
                const allExpanded = expandedModalSubjects.size === subjectAssignments.length;
                setExpandedModalSubjects(allExpanded ? new Set() : new Set(subjectAssignments.map((s) => s.subject_id)));
              }}
              sx={{ fontSize: 11.5, textTransform: "none", minWidth: "auto", color: "primary.main" }}>
              {expandedModalSubjects.size === subjectAssignments.length ? "Collapse all" : "Expand all"}
            </Button>
          </Box>
        )}

        <Box sx={{
          px: 3, pb: 2, maxHeight: "70vh", overflowY: "auto",
          "&::-webkit-scrollbar": { width: 6 },
          "&::-webkit-scrollbar-thumb": { bgcolor: "rgba(0,0,0,0.14)", borderRadius: 3 },
        }}>
          {subjectAssignments.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 5 }}>
              <MenuBookIcon sx={{ fontSize: 34, color: "text.disabled", mb: 1 }} />
              <Typography sx={{ fontSize: 12.5, color: "text.secondary", lineHeight: 1.6 }}>
                No subjects configured yet.<br />Add subjects &amp; grades in Settings &gt; Grades &amp; Subjects.
              </Typography>
            </Box>
          ) : (
            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 1.25, alignItems: "start" }}>
              {subjectAssignments.map((subj, si) => {
                const selected = subjectGradeSelections[subj.subject_id] || [];
                const isOpen = expandedModalSubjects.has(subj.subject_id);
                const allGradeIds = subj.grades.map((g) => g.grade_id);
                const allSelected = allGradeIds.length > 0 && selected.length === allGradeIds.length;
                const color = SUBJECT_COLORS[si % SUBJECT_COLORS.length];
                const hasSel = selected.length > 0;
                return (
                  <Box key={subj.subject_id} sx={{
                    border: `1px solid ${hasSel ? alpha(color, 0.4) : "rgba(0,0,0,0.08)"}`,
                    borderRadius: "12px", overflow: "hidden",
                    boxShadow: hasSel ? `0 1px 8px ${alpha(color, 0.12)}` : "none",
                    transition: "border-color 0.15s, box-shadow 0.15s",
                  }}>
                    {/* Subject header */}
                    <Box onClick={() => toggleModalSubjectExpanded(subj.subject_id)}
                      sx={{
                        display: "flex", alignItems: "center", gap: 1.25, px: 1.5, py: 1.25,
                        cursor: "pointer", userSelect: "none",
                        bgcolor: hasSel ? alpha(color, 0.05) : "transparent",
                        "&:hover": { bgcolor: hasSel ? alpha(color, 0.08) : "rgba(0,0,0,0.02)" },
                      }}>
                      <Box sx={{
                        width: 34, height: 34, borderRadius: "9px", flexShrink: 0,
                        bgcolor: alpha(color, 0.12), color,
                        display: "flex", alignItems: "center", justifyContent: "center",
                      }}>
                        <MenuBookIcon sx={{ fontSize: 18 }} />
                      </Box>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography sx={{ fontSize: 13.5, fontWeight: 700, letterSpacing: "-0.01em" }} noWrap>{subj.subject_name}</Typography>
                        <Typography sx={{ fontSize: 11, color: hasSel ? color : "text.disabled", fontWeight: hasSel ? 600 : 400 }}>
                          {hasSel ? `${selected.length} of ${subj.grades.length} grades` : `${subj.grades.length} grades available`}
                        </Typography>
                      </Box>
                      {hasSel && (
                        <Box sx={{
                          minWidth: 22, height: 22, px: 0.75, borderRadius: "11px",
                          bgcolor: color, color: "#fff", fontSize: 11, fontWeight: 700,
                          display: "flex", alignItems: "center", justifyContent: "center",
                        }}>
                          {selected.length}
                        </Box>
                      )}
                      {isOpen ? <ExpandLessIcon sx={{ fontSize: 20, color: "text.disabled" }} /> : <ExpandMoreIcon sx={{ fontSize: 20, color: "text.disabled" }} />}
                    </Box>
                    <Collapse in={isOpen}>
                      <Box sx={{ px: 1.5, pb: 1.5, pt: 1, borderTop: `1px solid ${alpha(color, 0.14)}` }}>
                        {subj.grades.length === 0 ? (
                          <Typography sx={{ fontSize: 12, color: "text.disabled", py: 0.5 }}>
                            This subject isn't offered in any grade yet.
                          </Typography>
                        ) : (
                          <>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
                              <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: "text.disabled", textTransform: "uppercase", letterSpacing: "0.06em" }}>Grades</Typography>
                              <Button size="small"
                                onClick={() => setSubjectGradeSelections((prev) => ({ ...prev, [subj.subject_id]: allSelected ? [] : allGradeIds }))}
                                sx={{ fontSize: 10.5, textTransform: "none", minWidth: "auto", color, "&:hover": { bgcolor: alpha(color, 0.06) } }}>
                                {allSelected ? "Clear all" : "Select all"}
                              </Button>
                            </Box>
                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
                              {subj.grades.map((g) => {
                                const on = selected.includes(g.grade_id);
                                return (
                                  <Box key={g.grade_id} onClick={() => toggleModalGrade(subj.subject_id, g.grade_id)}
                                    sx={{
                                      display: "inline-flex", alignItems: "center", gap: 0.5,
                                      px: 1.25, py: 0.65, borderRadius: "9px", cursor: "pointer",
                                      fontSize: 12.5, fontWeight: on ? 600 : 500, lineHeight: 1,
                                      border: `1.5px solid ${on ? color : "rgba(0,0,0,0.1)"}`,
                                      bgcolor: on ? alpha(color, 0.1) : "#fff",
                                      color: on ? color : "text.secondary",
                                      transition: "all 0.12s",
                                      "&:hover": { borderColor: color, bgcolor: alpha(color, on ? 0.15 : 0.05) },
                                    }}>
                                    {on && <CheckRoundedIcon sx={{ fontSize: 14 }} />}
                                    {g.grade_name}
                                  </Box>
                                );
                              })}
                            </Box>
                          </>
                        )}
                      </Box>
                    </Collapse>
                  </Box>
                );
              })}
            </Box>
          )}
        </Box>

        {/* Footer */}
        <Box sx={{
          display: "flex", alignItems: "center", justifyContent: "space-between", px: 3, py: 2,
          borderTop: "1px solid rgba(0,0,0,0.06)", bgcolor: "rgba(0,0,0,0.015)",
        }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            <CheckCircleOutlineIcon sx={{ fontSize: 16, color: totalSelectedGrades ? theme.palette.primary.main : "text.disabled" }} />
            <Typography sx={{ fontSize: 12, fontWeight: 600, color: totalSelectedGrades ? "text.primary" : "text.secondary" }}>
              {totalSelectedGrades} {totalSelectedGrades === 1 ? "assignment" : "assignments"} selected
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button variant="text" size="small" onClick={() => setAssignModalOpen(false)}
              sx={{ textTransform: "none", fontSize: 12.5, borderRadius: "10px", color: "text.secondary", px: 2 }}>
              Cancel
            </Button>
            <Button variant="contained" size="small" onClick={handleSaveAssignment}
              disabled={savingSubjectAssignment}
              sx={{ textTransform: "none", fontSize: 12.5, fontWeight: 600, borderRadius: "10px", boxShadow: "none", px: 3.5 }}>
              {savingSubjectAssignment ? <CircularProgress size={16} color="inherit" /> : "Save Changes"}
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* ══════════ Image Dialog ══════════ */}
      <Dialog open={openImage} onClose={() => { setOpenImage(false); setSelectedImage(undefined); }} maxWidth="xs" fullWidth
        PaperProps={{ sx: { borderRadius: "16px" } }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 3, py: 1.75 }}>
          <Typography sx={{ fontSize: 15, fontWeight: 700 }}>Profile Picture</Typography>
          <IconButton size="small" onClick={() => { setOpenImage(false); setSelectedImage(undefined); }}><CloseIcon sx={{ fontSize: 18 }} /></IconButton>
        </Box>
        <Divider />
        <DialogContent sx={{ textAlign: "center", py: 3 }}>
          <Avatar src={selectedImage ? URL.createObjectURL(selectedImage) : selectedEmpImg || undefined}
            sx={{
              width: 130, height: 130, mx: "auto", mb: 2, fontSize: 36, fontWeight: 700,
              background: !selectedImage && !selectedEmpImg ? `linear-gradient(135deg, ${theme.palette.primary.main}, ${alpha(theme.palette.primary.main, 0.6)})` : undefined,
              color: "#fff",
            }}>
            {!selectedImage && !selectedEmpImg ? initials : null}
          </Avatar>
          <Stack direction="row" spacing={1} justifyContent="center">
            <input accept="image/*" style={{ display: "none" }} id="profile-upload" type="file" onChange={handleImageChange} />
            <label htmlFor="profile-upload">
              <Button variant="outlined" component="span" size="small" startIcon={<CloudUploadIcon />} sx={{ textTransform: "none", fontSize: 11.5, borderRadius: "8px" }}>
                {selectedEmpImg ? "Change" : "Upload"}
              </Button>
            </label>
            {selectedEmpImg && (
              <Button variant="outlined" size="small" component="a" href={selectedEmpImg} target="_blank" startIcon={<DownloadOutlinedIcon />} sx={{ textTransform: "none", fontSize: 11.5, borderRadius: "8px" }}>Download</Button>
            )}
            {(selectedEmpImg || selectedImage) && (
              <Button variant="outlined" color="error" size="small" startIcon={<DeleteOutlineIcon />} onClick={() => formikRemoved.submitForm()} disabled={saveIsLoading} sx={{ textTransform: "none", fontSize: 11.5, borderRadius: "8px" }}>Remove</Button>
            )}
          </Stack>
        </DialogContent>
        {selectedImage && (
          <>
            <Divider />
            <DialogActions sx={{ px: 3, py: 1.5 }}>
              <Button variant="contained" size="small" onClick={() => formik.submitForm()} disabled={!selectedImage || saveIsLoading}
                sx={{ textTransform: "none", fontSize: 12, px: 3, boxShadow: "none", borderRadius: "8px" }}>
                {saveIsLoading ? <CircularProgress size={14} color="inherit" /> : "Save"}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* ══════════ Reset Password Dialog ══════════ */}
      {openResetPassword && portalUser && (
        <ChangePassword
          openModel={openResetPassword}
          handleCloseDialog={() => setOpenResetPassword(false)}
          data={portalUser}
        />
      )}

      {/* ══════════ Delete Popup ══════════ */}
      {coursingToDelete && (
        <DeletePopup open={openDeleteCategory}
          handleCloseDelete={() => { setCoursingToDelete(null); setOpenDeleteCategory(false); }}
          onConfirm={async () => { await handleDelete(coursingToDelete.id.toString()); }}
          title="Delete Staff" content={`Are you sure you want to delete "${fullName}"?`} />
      )}

      {/* ── Communication timeline (Pass E) ─────────────────────
             Scoped server-side to this staff member's `teamEmail`
             and `teamMobileNum` — no cross-staff leakage. */}
      {staffId && (
        <Box sx={{ mt: 3 }}>
          <ProfileTimelineSection profileType="staff" profileId={Number(staffId)} />
        </Box>
      )}
    </Box>
  );
};

export default Index;
